var _defs, _g, _g2, _g3, _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g4, _g5, _path16, _path17, _path18, _path19, _rect3, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect4, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _circle, _circle2, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 776.709,
    height: 488.206,
    viewBox: "0 0 776.709 488.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6307",
    "data-name": "Path 6307",
    d: "M591.513,355.661l-2.952,26.8a5.98,5.98,0,0,1-.152,1.007,11.712,11.712,0,0,1-11.712,9.194H563.534a4.076,4.076,0,0,1-3.97-4.931l6.207-32.161a4.532,4.532,0,0,1,4.415-3.607H588.2a3.4,3.4,0,0,1,3.361,3.771Z",
    transform: "translate(-559.472 -351.96)",
    fill: "#f30813"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Under_construction-pana_1_",
    "data-name": "Under construction-pana (1)",
    transform: "translate(-46.109 -46.871)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-34",
    transform: "translate(46.109 66.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6120",
    "data-name": "Path 6120",
    d: "M77.522,139.4s-13.633,5.165,1.3,34.2S104.1,216.987,104.1,216.987s2.647,6.746-3.033,7.812-18.2-.89-20.707,6.078c-2.6,7.226,2.659,14.054,13.3,19.91s33.484,19.781,35.545,21.081,4.052,4.369.3,5.715-31.891,4.4-29.654,17.65,34.608,24.923,38.122,26.258,4.357,2.834,4.076,4.755-9.838,2.061-17.8,3.256-16.994,3.959-15.061,11.513,21.081,23.342,67.647,27.745l21.679.621,11.712-18.294c22.733-40.816,20.589-65.586,15.46-71.442s-12.52,0-18.013,5.856-11.021,13.691-12.766,12.883-2.495-2.4-1.6-6.055,9.615-36.939,0-46.3-28.108,12.11-31.341,14.441-4.685-1.171-4.544-3.514,1.651-29.08,2.8-41.214-1.476-20.32-8.9-22.252c-7.156-1.874-12.637,9.545-16.736,13.621s-8.2-1.932-8.2-1.932-5.985-16.643-21.444-45.407S77.229,139.6,77.229,139.6",
    transform: "translate(-41.706 -50.418)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6121",
    "data-name": "Path 6121",
    d: "M196.906,370.561c-11.267-21.175-30.673-59.121-47.491-91.622s-32.149-61.909-43.287-83.119C100.553,185.28,96.021,176.66,92.882,170.7c-1.546-2.951-2.752-5.247-3.6-6.828-.4-.773-.7-1.359-.914-1.792a6.551,6.551,0,0,1-.293-.609s.129.187.351.586L89.4,163.8l3.713,6.781c3.209,5.856,7.8,14.429,13.433,25.016,11.278,21.163,26.6,50.525,43.427,83.013s36.154,70.482,47.316,91.7",
    transform: "translate(-38.924 -46.468)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6122",
    "data-name": "Path 6122",
    d: "M94,220.29a8.4,8.4,0,0,1,1.523.422c.96.3,2.342.785,4.029,1.394,3.385,1.241,8.023,3.057,13.106,5.153l12.965,5.423,3.935,1.616a7.378,7.378,0,0,1,1.429.644,6.4,6.4,0,0,1-1.511-.4c-.96-.3-2.342-.8-4.029-1.417-3.373-1.265-7.987-3.15-13.07-5.247L99.352,222.55l-3.947-1.593A6.85,6.85,0,0,1,94,220.29Z",
    transform: "translate(-37.911 -36.399)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6123",
    "data-name": "Path 6123",
    d: "M126.831,237.937c-.164-.07,3.162-9.791,7.437-21.725s7.894-21.55,8.069-21.491-3.15,9.791-7.437,21.725S127.03,238,126.831,237.937Z",
    transform: "translate(-32.292 -40.776)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6124",
    "data-name": "Path 6124",
    d: "M147,280.162a7.1,7.1,0,0,1,.878-1.347l2.565-3.514c2.143-2.975,5.106-7.1,8.2-11.77s5.774-8.983,7.683-12.122l2.26-3.724a8.9,8.9,0,0,1,.89-1.335,6.065,6.065,0,0,1-.668,1.464c-.468.914-1.171,2.225-2.073,3.83-1.8,3.209-4.415,7.578-7.531,12.262s-6.125,8.772-8.386,11.712c-1.171,1.441-2.061,2.612-2.729,3.4A7.391,7.391,0,0,1,147,280.162Z",
    transform: "translate(-28.838 -31.938)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6125",
    "data-name": "Path 6125",
    d: "M115,271.527a5.712,5.712,0,0,1,1.476,0l4.017.3c3.385.293,8.058.738,13.211,1.265s9.826,1.042,13.2,1.452l3.994.515a6.377,6.377,0,0,1,1.452.281,6.486,6.486,0,0,1-1.476,0l-4.017-.3c-3.385-.293-8.058-.738-13.223-1.265s-9.814-1.042-13.188-1.452l-3.994-.515A6.171,6.171,0,0,1,115,271.527Z",
    transform: "translate(-34.316 -27.637)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6126",
    "data-name": "Path 6126",
    d: "M127.89,312.266a10.54,10.54,0,0,1,1.886,0l5.153.375c4.333.34,10.33.867,16.947,1.476s12.6,1.171,16.935,1.675l5.13.586a10.392,10.392,0,0,1,1.874.3,9.809,9.809,0,0,1-1.9,0l-5.153-.375c-4.333-.34-10.33-.867-16.947-1.487s-12.6-1.171-16.935-1.675l-5.13-.574a10.314,10.314,0,0,1-1.862-.3Z",
    transform: "translate(-32.109 -20.662)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6127",
    "data-name": "Path 6127",
    d: "M167.85,322.087a12.38,12.38,0,0,1,1.066-1.733l3.08-4.579c2.6-3.877,6.172-9.241,9.943-15.225s7.027-11.571,9.369-15.6c1.171-1.932,2.061-3.514,2.787-4.778a12.061,12.061,0,0,1,1.077-1.71,10.049,10.049,0,0,1-.855,1.839c-.586,1.171-1.464,2.834-2.588,4.884-2.249,4.087-5.458,9.686-9.252,15.729s-7.414,11.372-10.107,15.225c-1.359,1.9-2.471,3.42-3.256,4.462A11.644,11.644,0,0,1,167.85,322.087Z",
    transform: "translate(-25.269 -26.442)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6128",
    "data-name": "Path 6128",
    d: "M529.475,405.16c-31.247-20.414-39.422-59.859-39.317-95.545,0-5.95-.832-12.2,1.827-17.509s9.17-9.088,14.569-6.746c4.486,1.944,6.57,7.027,9.182,11.2a34.714,34.714,0,0,0,14.37,12.883c3.842,1.85,8.573,2.9,12.251.726,5.036-2.986,5.423-10.1,5.2-16.022l-1.171-33.074c-.223-5.926-.433-11.958,1.241-17.638s5.563-11.021,11.15-12.766,12.637,1.277,14.054,7.027c.574,2.342.164,4.919.4,7.367s1.476,5.13,3.83,5.751,4.685-1.171,6.406-2.928c5.926-6.16,9.826-13.984,13.469-21.761s7.156-15.729,12.485-22.416,12.883-12.1,21.315-12.883,17.65,4.2,20.051,12.45-2.2,16.9-7.285,23.822a132.342,132.342,0,0,1-26.691,27.066c-1.827,1.382-3.795,2.881-4.439,5.095-1.171,3.982,2.694,7.788,6.629,8.96,4.451,1.335,9.229.726,13.855,1.171s9.7,2.342,11.583,6.594c2.612,5.973-2.249,12.461-7.1,16.771a113.148,113.148,0,0,1-32.9,20.379c-4.3,1.722-8.842,3.268-12.251,6.43s-5.376,8.561-3.115,12.66,7.73,5.27,12.262,4.286,8.538-3.6,12.883-5.364c8.034-3.326,18.552-3.092,23.986,3.771,3.572,4.521,4.064,10.939,2.506,16.5s-4.919,10.412-8.515,14.9c-12.555,15.706-28.858,28.53-47.527,35.663s-36.084,9.44-55.046,3.174",
    transform: "translate(29.883 -41.458)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6129",
    "data-name": "Path 6129",
    d: "M531,381.812c4.685-18.153,11.478-37.618,19.278-57.739q2.951-7.542,5.856-14.886c1.932-4.872,3.841-9.709,6-14.335a264.342,264.342,0,0,1,13.925-25.766c4.825-8,9.7-15.413,14.3-22.252s9.053-13.234,13.34-18.844a210.44,210.44,0,0,1,22.159-24.934c2.846-2.729,5.106-4.767,6.664-6.137l1.78-1.546a4.923,4.923,0,0,1,.632-.492,4.956,4.956,0,0,1-.55.586l-1.71,1.616c-1.511,1.417-3.736,3.514-6.523,6.289a221.454,221.454,0,0,0-21.842,25.1c-4.228,5.622-8.62,11.969-13.2,18.879s-9.369,14.335-14.195,22.323a269.683,269.683,0,0,0-13.82,25.766c-2.132,4.591-4.017,9.369-5.95,14.277s-3.853,9.85-5.856,14.874c-7.788,20.109-14.593,39.516-19.313,57.6",
    transform: "translate(36.896 -40.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6130",
    "data-name": "Path 6130",
    d: "M559.338,289.677a13.084,13.084,0,0,1-.656-2.506c-.363-1.628-.808-3.994-1.312-6.933-1.019-5.856-2.155-14.054-3.361-23s-2.459-17.1-3.572-22.932c-.539-2.928-1.007-5.282-1.347-6.91a10.729,10.729,0,0,1-.41-2.553,12.585,12.585,0,0,1,.82,2.459c.469,1.593,1.054,3.935,1.687,6.84,1.312,5.856,2.682,13.949,3.9,22.943s2.237,16.9,3.045,23.037q.585,4.169.972,7.027A11.1,11.1,0,0,1,559.338,289.677Z",
    transform: "translate(39.922 -35.62)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6131",
    "data-name": "Path 6131",
    d: "M633.42,266.011a16.934,16.934,0,0,1-3.022.457c-1.944.234-4.767.562-8.2,1.066-6.945.972-16.49,2.647-26.937,4.954s-19.816,4.837-26.539,6.851c-3.373.984-6.078,1.85-7.952,2.436a16.02,16.02,0,0,1-2.951.82,17.223,17.223,0,0,1,2.811-1.23c1.839-.714,4.509-1.7,7.859-2.776,6.688-2.2,16.057-4.837,26.539-7.179a270.546,270.546,0,0,1,27.09-4.685c3.513-.41,6.324-.621,8.292-.726a16.083,16.083,0,0,1,3.01.012Z",
    transform: "translate(41.487 -28.586)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6132",
    "data-name": "Path 6132",
    d: "M537.766,367.29a3.516,3.516,0,0,1-.55-.914l-1.382-2.705c-1.171-2.342-2.834-5.856-4.8-10.131-3.947-8.6-9.018-20.648-14.429-33.964s-10.377-25.473-14.136-34.14l-4.474-10.26-1.171-2.8a4.26,4.26,0,0,1-.351-1.007,3.514,3.514,0,0,1,.551.914c.375.726.832,1.628,1.394,2.705,1.171,2.342,2.823,5.856,4.79,10.119,3.947,8.608,9.018,20.66,14.441,34.046s10.365,25.461,14.125,34.128l4.439,10.178,1.171,2.8a3.668,3.668,0,0,1,.386,1.031Z",
    transform: "translate(30.985 -27.655)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6133",
    "data-name": "Path 6133",
    d: "M631.819,322.76a4.121,4.121,0,0,1-.984.445l-2.9,1.078-10.716,3.841c-9.053,3.256-21.5,7.882-35.253,13.024s-26.246,9.662-35.37,12.719c-4.556,1.534-8.2,2.741-10.833,3.514l-2.975.878a4.124,4.124,0,0,1-1.054.234,4.086,4.086,0,0,1,1-.445l2.9-1.077,10.716-3.841c9.042-3.244,21.491-7.882,35.241-13.012s26.258-9.662,35.37-12.719c4.556-1.534,8.2-2.741,10.833-3.514l2.975-.878A4.122,4.122,0,0,1,631.819,322.76Z",
    transform: "translate(37.021 -18.858)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6134",
    "data-name": "Path 6134",
    d: "M169.658,101.869c.937-6.863-8.737-12.508-16.022-13.094-3.514-.281-7.027.258-10.353-.89-7.121-2.483-9.967-11.712-16.912-14.616-5.2-2.19-11.185-.234-16.221,2.342s-10.014,5.7-15.635,6.032c-4.9.316-10.213-1.5-14.5.89-3.186,1.792-4.86,5.458-7.8,7.636s-6.629,2.565-10.2,2.764-7.261.223-10.541,1.722-5.938,4.919-5.259,8.433Z",
    transform: "translate(-46.109 -61.729)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6135",
    "data-name": "Path 6135",
    d: "M583.51,155.688c.984-7.1-9.042-12.883-16.572-13.539-3.584-.293-7.32.258-10.716-.925-7.367-2.577-10.306-12.087-17.5-15.12-5.376-2.272-11.571-.258-16.783,2.342s-10.353,5.926-16.186,6.3c-5.06.328-10.541-1.558-14.991.925-3.3,1.839-5.024,5.645-8.069,7.882s-6.863,2.67-10.541,2.869-7.519.234-10.892,1.78-6.137,5.095-5.446,8.725Z",
    transform: "translate(24.007 -52.691)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6136",
    "data-name": "Path 6136",
    d: "M704.653,180.582c.6-4.369-5.563-7.964-10.2-8.339-2.214-.176-4.509.164-6.605-.574-4.532-1.581-6.348-7.437-10.775-9.311-3.3-1.394-7.121-.152-10.33,1.464s-6.371,3.654-9.967,3.877c-3.115.2-6.5-.96-9.229.574-2.026,1.171-3.092,3.514-4.966,4.849a11.876,11.876,0,0,1-6.5,1.8,18.083,18.083,0,0,0-6.7,1.089c-2.073.949-3.795,3.139-3.361,5.376Z",
    transform: "translate(53.15 -46.42)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6137",
    "data-name": "Path 6137",
    d: "M694.832,97.549c1.1-7.952-10.131-14.5-18.563-15.225-4.017-.328-8.2.293-12.016-1.042-8.2-2.869-11.548-13.539-19.606-16.935-6.02-2.495-12.942-.223-18.8,2.705s-11.606,6.641-18.13,7.027c-5.68.363-11.841-1.733-16.806,1.031-3.7,2.073-5.633,6.336-9.041,8.842s-7.695,2.987-11.829,3.209-8.432.269-12.192,1.991-6.887,5.715-6.114,9.791Z",
    transform: "translate(40.426 -63.277)",
    fill: "#ebebeb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-34",
    transform: "translate(166.473 46.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6138",
    "data-name": "Path 6138",
    d: "M283.182,117.531c3.221-1.382,6.664,1.558,8.421,4.591s3.174,6.7,6.383,8.1c2.495,1.089,5.364.468,8.093.574,8.374.328,14.862,7.554,18.622,15.05,2.342,4.685,4.052,10.06,2.495,15.038-1.37,4.38-5.06,7.636-8.9,10.142a44.142,44.142,0,0,1-26.152,7.425,33.777,33.777,0,0,1-24.126-11.782c-4.509-5.528-6.91-12.52-7.952-19.57s-.808-14.218-.574-21.339",
    transform: "translate(-129.98 -34.836)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6139",
    "data-name": "Path 6139",
    d: "M316.356,153.208c-.059,0,0-.761-.141-2.085a16.045,16.045,0,0,0-1.558-5.411,17.485,17.485,0,0,0-5.282-6.371,22.065,22.065,0,0,0-9.37-3.947c-3.572-.644-7.133-.316-10.33-1a16.4,16.4,0,0,1-7.554-3.912A25.847,25.847,0,0,1,278.3,126.2c-.387-.55-.679-.984-.867-1.3a2.866,2.866,0,0,1-.258-.48,18.856,18.856,0,0,1,1.312,1.64,29.593,29.593,0,0,0,3.912,4.1,16.057,16.057,0,0,0,7.39,3.689c3.08.632,6.629.293,10.318.949a22.018,22.018,0,0,1,9.58,4.1,17.568,17.568,0,0,1,5.341,6.629,15.507,15.507,0,0,1,1.405,5.575,10.535,10.535,0,0,1,0,1.558,1.9,1.9,0,0,1-.082.55Z",
    transform: "translate(-126.917 -33.596)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6140",
    "data-name": "Path 6140",
    d: "M369.408,135.93,357.076,182.1l-25.04-26.937a65.188,65.188,0,0,0-38.883-10.541h0L254.2,142.8l-21.5,7.742a79.525,79.525,0,0,0-14.827,7.2l-41.9,28.916c-8.866,6.406-16.151,11.3-17.861,21.081-2.249,12.883,4.275,27.324,17.849,29.713l59.274.714,1.827,37.478,93.168-8.667-2.495-56.556c19.02,14.651,27.956,20.355,42.268,17.568,4.767-.925,11.583-5.938,13.8-13.363,7.905-26.469,9.252-68.1,9.252-68.1ZM223.292,202.184l5.411-1.534.34,1.956Z",
    transform: "translate(-147.376 -31.626)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6141",
    "data-name": "Path 6141",
    d: "M172.53,228.1h7.624l20.824-.059h68.947l-.3.293c0-.679.07-1.405.105-2.132.433-9.311.855-18.317,1.241-26.691l.269.316c-20.976-1.956-38.953-4.978-51.778-6.605-6.418-.843-11.548-1.405-15.061-1.815l-4.029-.445-1.042-.129-.351-.059h.363l1.042.082,4.041.351c3.514.34,8.655.855,15.085,1.651,12.883,1.523,30.826,4.462,51.778,6.383h.281v.281c-.386,8.362-.8,17.38-1.171,26.691,0,.726-.07,1.452-.105,2.12v.293H270l-68.947-.234-20.941-.152-5.657-.07h-1.464A2.847,2.847,0,0,1,172.53,228.1Z",
    transform: "translate(-144.832 -22.238)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6142",
    "data-name": "Path 6142",
    d: "M173.55,188.775a3.513,3.513,0,0,1,.949-.468,20.745,20.745,0,0,1,2.741-.9,27.254,27.254,0,0,1,18.633,1.874,19.611,19.611,0,0,1,2.506,1.429,3.806,3.806,0,0,1,.843.644c-.07.094-1.323-.726-3.514-1.687a30.029,30.029,0,0,0-18.364-1.839C174.991,188.33,173.585,188.88,173.55,188.775Z",
    transform: "translate(-144.657 -22.96)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6143",
    "data-name": "Path 6143",
    d: "M184.56,179.26a11.546,11.546,0,0,1,2.553,1.359,47.481,47.481,0,0,1,5.61,4.123c2.038,1.768,3.912,3.514,4.685,5.188a4.6,4.6,0,0,1,.48,2.108,1.546,1.546,0,0,1-.176.773,6.055,6.055,0,0,0-.679-2.682,20.835,20.835,0,0,0-4.685-4.919c-2.05-1.757-4.017-3.209-5.458-4.228a16.92,16.92,0,0,1-2.331-1.722Z",
    transform: "translate(-142.772 -24.209)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6144",
    "data-name": "Path 6144",
    d: "M220.085,196.682a23.692,23.692,0,0,1-1.054-3.666c-.586-2.272-1.359-5.423-2.342-8.866s-1.944-6.535-2.752-8.737a29.422,29.422,0,0,1-1.265-3.584,3.4,3.4,0,0,1,.527.89c.3.586.691,1.452,1.171,2.541a78.935,78.935,0,0,1,2.928,8.725c.949,3.514,1.651,6.641,2.132,8.936a23.311,23.311,0,0,1,.656,3.759Z",
    transform: "translate(-137.961 -25.481)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6145",
    "data-name": "Path 6145",
    d: "M304.255,231.131c-.164,0-.832-14.054-1.5-31.423s-1.066-31.458-.89-31.458.843,14.054,1.5,31.435S304.431,231.131,304.255,231.131Z",
    transform: "translate(-122.699 -26.093)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10786",
    "data-name": "Group 10786",
    transform: "translate(179.671 148.61)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6146",
    "data-name": "Path 6146",
    d: "M302.29,173.76c.972,6.043,3.514,11.712,5.61,17.462s3.514,12.016,2.272,18l-7.027-5.633",
    transform: "translate(-302.29 -173.76)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6147",
    "data-name": "Path 6147",
    d: "M334.046,200.216a3.784,3.784,0,0,1-.539-.878c-.316-.586-.714-1.452-1.171-2.541a55.96,55.96,0,0,1-4.322-17.919c-.082-1.171-.105-2.143-.094-2.8a3.993,3.993,0,0,1,.094-1.077,32.8,32.8,0,0,1,.457,3.795,72.7,72.7,0,0,0,4.228,17.837A35.75,35.75,0,0,1,334.046,200.216Z",
    transform: "translate(-118.232 -24.938)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6148",
    "data-name": "Path 6148",
    d: "M214.08,175.1l1.511,19.828,3.455-.984Z",
    transform: "translate(-137.719 -24.921)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6149",
    "data-name": "Path 6149",
    d: "M316.554,178.2a1.008,1.008,0,0,1-.3-.129l-.878-.422a25.826,25.826,0,0,0-3.455-1.359,26.551,26.551,0,0,0-13.457-.679,28.307,28.307,0,0,0-8.667,3.514c-2.916,1.71-5.856,3.888-9.042,6.008a34.738,34.738,0,0,1-10.892,5.13,31.834,31.834,0,0,1-12.883.527,35.864,35.864,0,0,1-6.359-1.733,32.666,32.666,0,0,1-5.7-2.916,30.756,30.756,0,0,1-4.8-3.9,43.846,43.846,0,0,1-3.853-4.474c-2.342-3.069-4.3-6.125-6.313-8.866a39.3,39.3,0,0,0-6.266-7.027,24.886,24.886,0,0,0-6.57-4.041,17.018,17.018,0,0,0-5.68-1.277,15.226,15.226,0,0,0-4.919.7l.3-.129.914-.316c.41-.129.937-.223,1.546-.351a14.725,14.725,0,0,1,2.167-.141,16.4,16.4,0,0,1,5.786,1.171,24.91,24.91,0,0,1,6.734,4.029,38.286,38.286,0,0,1,6.383,7.027c2.05,2.729,4.029,5.786,6.36,8.807a44.588,44.588,0,0,0,3.818,4.415,30.544,30.544,0,0,0,4.685,3.806,32.677,32.677,0,0,0,5.6,2.858,33.707,33.707,0,0,0,6.254,1.686,31.188,31.188,0,0,0,12.66-.5,34.316,34.316,0,0,0,10.74-5.024c3.2-2.085,6.125-4.251,9.1-5.973a28.531,28.531,0,0,1,8.831-3.514,26.246,26.246,0,0,1,13.621.878,23.942,23.942,0,0,1,3.432,1.464l.843.48Z",
    transform: "translate(-139.015 -28.136)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6150",
    "data-name": "Path 6150",
    d: "M323.1,166.83a5.129,5.129,0,0,1,.129,1.441,20.248,20.248,0,0,1-.328,3.959,20.814,20.814,0,0,1-1.862,5.587,35.888,35.888,0,0,1-3.865,6.067,28.705,28.705,0,0,1-10.166,8.128,25.075,25.075,0,0,1-3.689,1.417,6.021,6.021,0,0,1-1.417.316c0-.117,1.968-.621,4.919-2.12a30.182,30.182,0,0,0,9.873-8.116,37.475,37.475,0,0,0,3.841-5.95,21.749,21.749,0,0,0,1.944-5.411,47.418,47.418,0,0,0,.621-5.317Z",
    transform: "translate(-122.686 -26.337)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6151",
    "data-name": "Path 6151",
    d: "M333.658,221.306a2.321,2.321,0,0,1-.445-.246,11,11,0,0,1-1.171-.832,19.232,19.232,0,0,1-3.759-3.877A28.987,28.987,0,0,1,323,199.569a58.817,58.817,0,0,1,3.033-17.474c.668-2.178,1.265-3.912,1.686-5.106a13.793,13.793,0,0,1,.726-1.839,13.616,13.616,0,0,1-.492,1.909c-.386,1.323-.9,3.057-1.511,5.153a63.116,63.116,0,0,0-2.834,17.357,29.56,29.56,0,0,0,4.989,16.572,26.386,26.386,0,0,0,5.06,5.165Z",
    transform: "translate(-119.074 -24.912)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6152",
    "data-name": "Path 6152",
    d: "M360.018,170.29a5.683,5.683,0,0,1-1.171.621c-.75.351-1.839.832-3.221,1.347a29.42,29.42,0,0,1-11.349,1.921,19.09,19.09,0,0,1-10.8-3.865,13.289,13.289,0,0,1-2.459-2.495,4.2,4.2,0,0,1-.679-1.089,23.975,23.975,0,0,0,3.408,3.244,19.664,19.664,0,0,0,10.541,3.6,31.74,31.74,0,0,0,11.185-1.722C358.308,170.935,359.971,170.2,360.018,170.29Z",
    transform: "translate(-117.817 -26.354)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6153",
    "data-name": "Path 6153",
    d: "M209.607,195.922c-.105,0-.574-1.827-1.663-4.685a52.9,52.9,0,0,0-13.223-19.828c-2.237-2.108-3.759-3.268-3.7-3.35a5.318,5.318,0,0,1,1.171.726,33.823,33.823,0,0,1,2.858,2.342,47.351,47.351,0,0,1,13.328,19.992,34.983,34.983,0,0,1,1.031,3.514,5.562,5.562,0,0,1,.2,1.288Z",
    transform: "translate(-141.667 -26.126)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6154",
    "data-name": "Path 6154",
    d: "M226.609,193.57a2.344,2.344,0,0,1-.3.621,13.488,13.488,0,0,1-1.113,1.663,18.259,18.259,0,0,1-5.692,4.685,33.706,33.706,0,0,1-10.353,3.385c-4.041.691-8.55.972-13.176,1.722a38.908,38.908,0,0,0-6.629,1.628,27.29,27.29,0,0,0-5.68,2.8,29,29,0,0,0-7.73,7.39,29.711,29.711,0,0,0-3.42,6.406c-.632,1.6-.832,2.541-.9,2.518a2.661,2.661,0,0,1,.129-.679,14.243,14.243,0,0,1,.55-1.921,27.545,27.545,0,0,1,3.291-6.57,28.553,28.553,0,0,1,7.777-7.613,27.255,27.255,0,0,1,5.786-2.893,39.749,39.749,0,0,1,6.723-1.675c4.685-.75,9.182-1.007,13.188-1.663a34.515,34.515,0,0,0,10.248-3.209,18.949,18.949,0,0,0,5.7-4.415C226.105,194.39,226.55,193.535,226.609,193.57Z",
    transform: "translate(-144.989 -21.759)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6155",
    "data-name": "Path 6155",
    d: "M240.853,196.32a4.811,4.811,0,0,1,.41,1.171,23.516,23.516,0,0,1,.691,3.256,31.039,31.039,0,0,1-2.3,16.724,29.5,29.5,0,0,1-2.342,4.357,23.755,23.755,0,0,1-1.991,2.67c-.527.586-.82.9-.855.867s1.042-1.382,2.483-3.759a35.753,35.753,0,0,0,2.19-4.357,36.649,36.649,0,0,0,1.792-5.669,35.839,35.839,0,0,0,.75-5.914,33.093,33.093,0,0,0-.164-4.86C241.216,198.018,240.736,196.343,240.853,196.32Z",
    transform: "translate(-134.229 -21.288)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6156",
    "data-name": "Path 6156",
    d: "M304.589,211.917a32.792,32.792,0,0,0-7.87-2.249,33.776,33.776,0,0,0-8.2.328,6.91,6.91,0,0,1,2.342-.726,19.3,19.3,0,0,1,11.618,1.382,6.863,6.863,0,0,1,2.108,1.265Z",
    transform: "translate(-124.976 -19.131)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6157",
    "data-name": "Path 6157",
    d: "M350.6,111.12,338.82,140.376l22.17,9.932,5.692-24.876Z",
    transform: "translate(-116.366 -35.873)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M379.091,145.329l-19.91-24.712h0c-4.017-5.551-10.412-14.488-10.7-15.225-.41-1.171-.562-9.159-.375-11.185a63.874,63.874,0,0,0-.5-7.777l-16.4,6.219L327.7,80l-2.249.7s-5.938,10.271-4.1,16.115,9.6,8.491,11.524,9.674,9.217,4.322,17.451,16.748l1.323,1.921h0l3.338,4.825h0l15.225,21.9a5.54,5.54,0,1,0,8.889-6.594Z",
    transform: "translate(-119.416 -41.2)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6159",
    "data-name": "Path 6159",
    d: "M337.836,89.75,333.55,77.664l1.546-.5s7.566,4.685,9.194,10.142Z",
    transform: "translate(-117.268 -41.686)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6160",
    "data-name": "Path 6160",
    d: "M333.3,102.209l.187-.082.515-.234,1.932-.867,7.027-3.186-.176-.105a18.723,18.723,0,0,0,0,2.143,6.031,6.031,0,0,0,.515,2.342c.808,1.382,1.792,2.741,2.8,4.193,2.026,2.869,4.275,5.985,6.652,9.217a2.928,2.928,0,0,1,.679,1.359,2.284,2.284,0,0,1-2.717,2.577,2.237,2.237,0,0,1-1.171-.691c-.293-.363-.586-.8-.878-1.171l-1.722-2.342-5.938-8.011a7.027,7.027,0,0,0-1.464-1.429c-.515-.387-1.019-.714-1.487-1.031-.949-.609-1.792-1.1-2.483-1.487s-1.241-.679-1.6-.878l-.433-.211h-.152l.141.082.41.246,1.569.925c.691.41,1.511.914,2.448,1.534.468.316.972.656,1.464,1.042a6.442,6.442,0,0,1,1.417,1.405l5.856,8.046,1.71,2.342c.293.4.562.785.89,1.171a2.647,2.647,0,0,0,1.382.785,2.6,2.6,0,0,0,3.1-2.928,3.291,3.291,0,0,0-.738-1.5c-2.342-3.232-4.685-6.336-6.676-9.205-1-1.441-2-2.811-2.787-4.146a5.856,5.856,0,0,1-.5-2.167,16.111,16.111,0,0,1,0-2.12v-.2l-.176.082-7.027,3.35-1.874.914-.48.234Z",
    transform: "translate(-117.311 -38.182)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10787",
    "data-name": "Group 10787",
    transform: "translate(214.35 51.284)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6161",
    "data-name": "Path 6161",
    d: "M332.017,97.511l7.367-2.729-.047-4.123L331.9,93.494Z",
    transform: "translate(-331.9 -90.66)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6162",
    "data-name": "Path 6162",
    d: "M336.959,90.45a7.612,7.612,0,0,0-.293,3.045,7.647,7.647,0,0,0,.351,3.033,7.332,7.332,0,0,0,.293-3.045,7.647,7.647,0,0,0-.351-3.033Z",
    transform: "translate(-116.742 -39.411)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6163",
    "data-name": "Path 6163",
    d: "M335.048,91.15a7.531,7.531,0,0,0-.281,3.045,7.4,7.4,0,0,0,.351,3.033,7.449,7.449,0,0,0,.281-3.045,7.4,7.4,0,0,0-.351-3.033Z",
    transform: "translate(-117.068 -39.292)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6164",
    "data-name": "Path 6164",
    d: "M333.229,91.6a7.566,7.566,0,0,0-.293,3.045,7.648,7.648,0,0,0,.351,3.033,7.612,7.612,0,0,0,.293-3.045,7.648,7.648,0,0,0-.351-3.033Z",
    transform: "translate(-117.38 -39.215)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6165",
    "data-name": "Path 6165",
    d: "M339.47,139.108l.8-5.727.539-15.225-.586-10.646s3.514.269,5.469,4.86,1.991,11.606,1.991,11.606,14.874,5.856,9.627,19.91",
    transform: "translate(-116.254 -36.491)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6166",
    "data-name": "Path 6166",
    d: "M357.774,115.489a5.774,5.774,0,0,0-.679-3.432A4.942,4.942,0,0,0,353.781,110a9.475,9.475,0,0,0-3.631,0l2.8,3.9a56.409,56.409,0,0,0-1.241,7.132c-.152,1.23-.141,2.764.925,3.4a2.342,2.342,0,0,0,2.741-.621,6.665,6.665,0,0,0,1.265-2.752,25.369,25.369,0,0,0,1.136-5.563Z",
    transform: "translate(-114.426 -36.096)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6167",
    "data-name": "Path 6167",
    d: "M361.364,119.339a5.95,5.95,0,0,0-.679-3.432,4.942,4.942,0,0,0-3.326-2.061,9.369,9.369,0,0,0-3.619,0l2.787,3.9a58.563,58.563,0,0,0-1.242,7.132c-.14,1.171-.14,2.764.937,3.4a2.342,2.342,0,0,0,2.741-.621,6.641,6.641,0,0,0,1.253-2.752,25.39,25.39,0,0,0,1.148-5.563Z",
    transform: "translate(-113.812 -35.437)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6168",
    "data-name": "Path 6168",
    d: "M365.114,123.139a5.856,5.856,0,0,0-.679-3.443,4.942,4.942,0,0,0-3.314-2.061,9.955,9.955,0,0,0-3.631,0l2.8,3.9a56.4,56.4,0,0,0-1.241,7.132c-.152,1.241-.141,2.764.925,3.408a2.342,2.342,0,0,0,2.741-.632,6.735,6.735,0,0,0,1.23-2.811,25.415,25.415,0,0,0,1.171-5.493Z",
    transform: "translate(-113.17 -34.787)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6169",
    "data-name": "Path 6169",
    d: "M356.612,112.31a10.857,10.857,0,0,1,.223,5.2,11.032,11.032,0,0,1-1.651,4.931c-.176-.07.668-2.225,1.054-5.024S356.437,112.333,356.612,112.31Z",
    transform: "translate(-113.569 -35.669)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6170",
    "data-name": "Path 6170",
    d: "M360.515,117.53a10.927,10.927,0,0,1-1.862,8.772c-.164-.094.785-1.9,1.277-4.31S360.328,117.542,360.515,117.53Z",
    transform: "translate(-112.974 -34.776)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6171",
    "data-name": "Path 6171",
    d: "M345,112.31a20.154,20.154,0,0,1,.644,3.068c.34,1.932.8,4.685,1.312,7.929l-.187-.234a16.01,16.01,0,0,1,9.7,9.369,16.511,16.511,0,0,1,1.171,5.61,16.08,16.08,0,0,1-.363,3.841,4.8,4.8,0,0,1-.4,1.359,31.712,31.712,0,0,0,.328-5.177,16.818,16.818,0,0,0-1.265-5.423,15.927,15.927,0,0,0-3.818-5.6,15.647,15.647,0,0,0-5.551-3.42h-.164v-.164c-.468-3.244-.843-6.008-1.089-7.964A22.354,22.354,0,0,1,345,112.31Z",
    transform: "translate(-115.308 -35.669)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6172",
    "data-name": "Path 6172",
    d: "M347.439,85.46l-.258.105-.75.281-2.764,1.031-9.088,3.514L325.5,93.9l-2.764,1.031-.761.269c-.164.07-.258.094-.258.082l.246-.117.738-.316,2.729-1.171c2.342-.925,5.516-2.19,9.053-3.514s6.769-2.565,9.124-3.4c1.171-.41,2.12-.738,2.787-.949l.761-.246a.925.925,0,0,1,.281-.117Z",
    transform: "translate(-119.293 -40.266)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6173",
    "data-name": "Path 6173",
    d: "M256.984,202.418s14.593-3.994,17.088-4.087c1.909-.059,12.977,1.815,18.071,2.694a3.7,3.7,0,0,1,3.127,4.111,3.088,3.088,0,0,1-.094.351,3.361,3.361,0,0,1-2.811,2.155,3.912,3.912,0,0,1,2.132,4.052c-.4,2.881-3.97,2.963-3.97,2.963s.176.187.422.515a3.514,3.514,0,0,1-2.565,5.516l-1.628.117a3.443,3.443,0,0,1,1.663,3.186c-.632,3.783-9.276,3.209-9.276,3.209l-23.213-.445Z",
    transform: "translate(-130.555 -20.945)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6174",
    "data-name": "Path 6174",
    d: "M287.953,196.861c-.281,1.171-.984,3.853-3.291,4.685L272.95,199.3s9.217-1.686,10.681-3a10.33,10.33,0,0,1,1.932-1.382,1.686,1.686,0,0,1,2.389,1.944Z",
    transform: "translate(-127.641 -21.56)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6175",
    "data-name": "Path 6175",
    d: "M277.71,199.3c0,.2,2.342.8,5.305,1.171s5.376.656,5.411.433-2.342-.8-5.305-1.171S277.745,199.09,277.71,199.3Z",
    transform: "translate(-126.827 -20.791)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6176",
    "data-name": "Path 6176",
    d: "M279.11,205.24c0,.2,1.968.878,4.556,1.171s4.685.105,4.685-.105-2.073-.363-4.614-.656S279.157,205.029,279.11,205.24Z",
    transform: "translate(-126.587 -19.773)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6177",
    "data-name": "Path 6177",
    d: "M274.122,203.742c-.187.082-.059.761.539,1.288s1.277.574,1.335.375-.363-.539-.82-.949S274.321,203.648,274.122,203.742Z",
    transform: "translate(-127.455 -20.02)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6178",
    "data-name": "Path 6178",
    d: "M277,211.436c0,.211,2.237.656,5.024.984s5.095.433,5.13.223-2.225-.644-5.036-.984S277.059,211.226,277,211.436Z",
    transform: "translate(-126.948 -18.72)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6179",
    "data-name": "Path 6179",
    d: "M271.784,207.87c-.094,0-.3.164-.433.621a2.436,2.436,0,0,0,.246,1.792,2.483,2.483,0,0,0,1.417,1.171c.445.117.738,0,.75-.059a4.765,4.765,0,0,1-1.5-1.464C271.725,208.959,271.983,207.94,271.784,207.87Z",
    transform: "translate(-127.928 -19.311)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6180",
    "data-name": "Path 6180",
    d: "M274.57,217.449c0,.211,2.061.445,4.6.515s4.614,0,4.614-.246-2.05-.445-4.591-.515S274.582,217.238,274.57,217.449Z",
    transform: "translate(-127.364 -17.717)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6181",
    "data-name": "Path 6181",
    d: "M269.511,213.4c-.094,0-.281.2-.34.656a2.963,2.963,0,0,0,.386,1.7c.7,1.171,1.616,1.7,1.745,1.569s-.492-.96-1.078-1.944S269.7,213.459,269.511,213.4Z",
    transform: "translate(-128.29 -18.365)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6182",
    "data-name": "Path 6182",
    d: "M220.293,104.156c-.468-3.759-4.591-6.395-8.327-5.856a10.119,10.119,0,0,0-7.777,7.378,16.326,16.326,0,0,0,1.171,11.033c1.171,2.717,3.232,5.4,6.149,6a7.976,7.976,0,0,0,7.25-2.893,23.423,23.423,0,0,0,3.865-7.168Z",
    transform: "translate(-139.493 -38.08)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6183",
    "data-name": "Path 6183",
    d: "M222.65,102.765a2.963,2.963,0,0,0-3.748.832,6.371,6.371,0,0,0-1.171,3.947,15.964,15.964,0,0,0,1.312,6.8,2.436,2.436,0,0,0,1.335,1.534,1.745,1.745,0,0,0,1.78-.656,4.309,4.309,0,0,0,.785-1.839,21.14,21.14,0,0,0-.574-11.817",
    transform: "translate(-137.095 -37.508)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6184",
    "data-name": "Path 6184",
    d: "M289.048,89.788c6.582-3.221,10.365-6.559,9.815-9.287s-13.8-6.957-16.9-8.1c-7.32-2.717-14.242,3.748-25.766,6.067-22.452,4.509-39.738,12.731-38.649,18.364.539,2.717,5.27,4.333,12.532,4.778",
    transform: "translate(-137.134 -42.614)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10788",
    "data-name": "Group 10788",
    transform: "translate(84.583 34.644)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6185",
    "data-name": "Path 6185",
    d: "M284.508,89.567c5.856-2.858,9.37-5.856,8.7-8.2-1.78-6.629-17.943-5.856-37.853-1.8s-35.217,11.243-34.21,16.268c.48,2.413,4.685,3.841,11.1,4.24",
    transform: "translate(-221.1 -76.452)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6186",
    "data-name": "Path 6186",
    d: "M230.714,99.646a28.108,28.108,0,0,1,23.494-32.723c14.862-2.214,28.717,8.2,31.751,22.9,2.659,12.883,5.048,25.942,5.247,30.708.586,14.382-7.531,20.425-10.845,22.252a18.645,18.645,0,0,1-3.736,1.171h0a.094.094,0,0,0-.07.117l4.076,16.326c2.026,10.74-3.514,20.695-14.206,22.85s-19.652-5.692-21.889-16.4Z",
    transform: "translate(-134.946 -43.49)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6187",
    "data-name": "Path 6187",
    d: "M274.723,94.32a2.342,2.342,0,0,1-1.71,2.705,2.19,2.19,0,0,1-2.717-1.558,2.342,2.342,0,0,1,1.71-2.705,2.19,2.19,0,0,1,2.717,1.558Z",
    transform: "translate(-128.103 -39.03)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6188",
    "data-name": "Path 6188",
    d: "M276.48,90.155c-.223.34-2.178-.574-4.591-.082s-3.935,2.05-4.251,1.815,0-.691.679-1.405a6.207,6.207,0,0,1,3.338-1.815,6.043,6.043,0,0,1,3.724.422C276.281,89.511,276.586,89.992,276.48,90.155Z",
    transform: "translate(-128.572 -39.738)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6189",
    "data-name": "Path 6189",
    d: "M254.468,98.391a2.342,2.342,0,0,1-1.71,2.705,2.2,2.2,0,0,1-2.752-1.558,2.342,2.342,0,0,1,1.71-2.705,2.19,2.19,0,0,1,2.752,1.558Z",
    transform: "translate(-131.576 -38.335)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6190",
    "data-name": "Path 6190",
    d: "M256.3,94.605c-.211.351-2.167-.562-4.579-.082s-3.935,2.061-4.263,1.815c-.152-.105,0-.691.679-1.405a6.383,6.383,0,0,1,3.338-1.815,6.031,6.031,0,0,1,3.724.433C256.031,93.973,256.394,94.441,256.3,94.605Z",
    transform: "translate(-132.014 -38.975)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6191",
    "data-name": "Path 6191",
    d: "M266.3,111.057a16.4,16.4,0,0,1,3.771-1.487c.609-.187,1.171-.433,1.171-.867a3.221,3.221,0,0,0-.773-1.745l-2.776-4.333c-3.865-6.172-6.8-11.3-6.559-11.454s3.6,4.685,7.472,10.9l2.694,4.369a3.643,3.643,0,0,1,.808,2.342,1.546,1.546,0,0,1-.832,1.1,3.981,3.981,0,0,1-1.019.363,15.636,15.636,0,0,1-3.959.808Z",
    transform: "translate(-129.667 -39.289)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6192",
    "data-name": "Path 6192",
    d: "M273.022,132.978s-9.17,2.635-22.253-2.038c0,0,6.16,11.583,23.33,6.43Z",
    transform: "translate(-131.438 -32.48)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6193",
    "data-name": "Path 6193",
    d: "M266.677,113.453a4.439,4.439,0,0,0-4.228-.832,4.017,4.017,0,0,0-2.436,2.014,2.541,2.541,0,0,0,.386,2.916,2.951,2.951,0,0,0,3.314.164,9.053,9.053,0,0,0,2.717-2.459,2.553,2.553,0,0,0,.55-.855.82.82,0,0,0-.187-.89",
    transform: "translate(-129.906 -35.653)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M259.792,110.8c.386-.105.914,2.518,3.514,3.923s5.352.562,5.446.925c.07.152-.515.632-1.687.9a6.664,6.664,0,0,1-4.521-.621,5.856,5.856,0,0,1-2.8-3.326C259.44,111.527,259.6,110.824,259.792,110.8Z",
    transform: "translate(-129.931 -35.928)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6195",
    "data-name": "Path 6195",
    d: "M256.03,87.875c-.105.7-2.577.878-5.341,1.792s-4.907,2.143-5.4,1.628c-.223-.246.059-.949.855-1.768a9.733,9.733,0,0,1,8.2-2.6C255.5,87.137,256.066,87.547,256.03,87.875Z",
    transform: "translate(-132.389 -40.034)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6196",
    "data-name": "Path 6196",
    d: "M274.568,85.025c-.316.632-2.1.4-4.1.773s-3.619,1.171-4.134.609c-.223-.246-.07-.843.574-1.511a6.02,6.02,0,0,1,6.617-1.171C274.345,84.194,274.7,84.721,274.568,85.025Z",
    transform: "translate(-128.79 -40.651)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6197",
    "data-name": "Path 6197",
    d: "M265.275,75.316a15.682,15.682,0,0,1-10.025,8.866c-2.916.832-6.383.984-8.2,3.385C245.7,89.323,245.7,91.712,245.4,93.9c-.48,3.338.363,7.179-2.178,9.369-1.991,1.722-3.865,1.675-5.083,4.005s-.984,5.622-.48,8.351,1.171,7.027-1.066,8.76c-2.085-9.885-7.425-20.461-9.5-30.345a12.075,12.075,0,0,1-.375-4.474c.586-3.35,3.795-5.528,6.828-7.027,8.608-4.31,18.095-6.523,27.464-8.7",
    transform: "translate(-135.566 -42.255)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6198",
    "data-name": "Path 6198",
    d: "M292.376,82.844s-10.611-22.733-11.349-23.8-9.639-10.154-26.516-9.885l-13.457,2.705s-17.872,9.99-20.425,15.331.492,28.249.492,28.249L257.205,79.67l26.937,1.1Z",
    transform: "translate(-136.772 -46.48)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6199",
    "data-name": "Path 6199",
    d: "M246.941,47.7l3.713-.75a3.865,3.865,0,0,1,3.959,1.581,11.923,11.923,0,0,1,1.616,3.619c1.113,4.134,7.824,32.641,7.824,32.641L247.023,87.4l-6.57-35.545-5.434,2.413-.105-1.054a3.162,3.162,0,0,1,.363-1.85h0a3.092,3.092,0,0,1,2.061-1.534Z",
    transform: "translate(-134.156 -46.871)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6200",
    "data-name": "Path 6200",
    d: "M287.07,82.357l-3.443-7.929L255.6,71.5,225.77,87.206l1.874,9.369S252.18,80.518,287.07,82.357Z",
    transform: "translate(-135.718 -42.655)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6201",
    "data-name": "Path 6201",
    d: "M281.705,72.793l1.335.855,10.236,4.86s-18.493-2.342-36.611,1.476S219,94.132,219,94.132l10.541-9.651h0a21.2,21.2,0,0,1,13.422-9.533l22.709-5.024a21.081,21.081,0,0,1,16.034,2.869Z",
    transform: "translate(-136.877 -43.012)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6202",
    "data-name": "Path 6202",
    d: "M290.38,78.244a4.151,4.151,0,0,0-.668-.386,10.659,10.659,0,0,0-2.061-.785,33.274,33.274,0,0,0-8.011-1.1,86.48,86.48,0,0,0-26.293,3.678c-4.989,1.382-9.779,2.6-14.054,4.111a108.186,108.186,0,0,0-11,4.685c-1.523.761-2.869,1.534-4.017,2.26a7.625,7.625,0,0,0-2.647,2.342,3.162,3.162,0,0,0-.445,2.2c.117.515.316.726.34.714a3.115,3.115,0,0,1,.445-2.705,7.507,7.507,0,0,1,2.612-2.026q1.757-1.019,4.041-2.108c3.057-1.405,6.8-3.01,10.986-4.486s9.006-2.635,14.054-4.017a93.847,93.847,0,0,1,26.012-3.935,38.062,38.062,0,0,1,7.917.761C289.4,77.845,290.321,78.349,290.38,78.244Z",
    transform: "translate(-136.51 -41.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6203",
    "data-name": "Path 6203",
    d: "M278.8,80.55c3.244,7.25,14.558,17.568,3.713,27.581,0,0-3.42-16.4-6.043-22.522a13.258,13.258,0,0,0-3.139-4.931",
    transform: "translate(-127.576 -41.106)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6204",
    "data-name": "Path 6204",
    d: "M232.456,92.13a14.64,14.64,0,0,0-11.712,16.479c.363,1.932,1.171,3.841.925,5.856s-1.265,3.6-1.745,5.458c-.949,3.678-1.171,9.733.129,13.328,2.975,8.55,13.82,19.09,23.646,17.123",
    transform: "translate(-136.852 -39.124)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6205",
    "data-name": "Path 6205",
    d: "M237.956,143.826a6.453,6.453,0,0,0,5.727-1.722,11.911,11.911,0,0,0,3.033-5.352,20.859,20.859,0,0,0-3.818-18.844,30.591,30.591,0,0,0,.375-28.928L229.5,93.056Z",
    transform: "translate(-135.079 -39.663)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6206",
    "data-name": "Path 6206",
    d: "M220.451,110.814a6.055,6.055,0,0,1-2.178,1.956,10.6,10.6,0,0,1-6.91,1.511,10.388,10.388,0,0,1-6.336-3.139,4.322,4.322,0,0,1-1.347-2.612,10.611,10.611,0,0,0,1.651,2.342,10.9,10.9,0,0,0,6.1,2.834,11.056,11.056,0,0,0,6.617-1.288C219.6,111.552,220.369,110.732,220.451,110.814Z",
    transform: "translate(-139.499 -36.316)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6207",
    "data-name": "Path 6207",
    d: "M219.346,109.626a5.856,5.856,0,0,1-2.424.867,12.426,12.426,0,0,1-11.489-3.7,5.949,5.949,0,0,1-1.452-2.132c.082,0,.632.761,1.757,1.827a13.469,13.469,0,0,0,11.115,3.584C218.386,109.86,219.311,109.532,219.346,109.626Z",
    transform: "translate(-139.448 -36.979)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6208",
    "data-name": "Path 6208",
    d: "M246.3,92.22a4.953,4.953,0,0,1-.082,1.382,18.738,18.738,0,0,1-.878,3.689,20.718,20.718,0,0,1-19.008,14.054,18.282,18.282,0,0,1-3.783-.246,4.778,4.778,0,0,1-1.347-.34,39.115,39.115,0,0,0,5.106.152,21.175,21.175,0,0,0,18.634-13.75A43.838,43.838,0,0,0,246.3,92.22Z",
    transform: "translate(-136.5 -39.108)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6209",
    "data-name": "Path 6209",
    d: "M246.7,109.85a4.894,4.894,0,0,1-.679.808,11.711,11.711,0,0,1-2.342,1.757,18.189,18.189,0,0,1-9.217,2.342,36.658,36.658,0,0,1-9.369-1.452c-1.171-.328-2.108-.609-2.752-.832a3.783,3.783,0,0,1-.984-.386,30.061,30.061,0,0,1,3.841.8,43.146,43.146,0,0,0,9.3,1.265,19.313,19.313,0,0,0,9.006-2.1,30.373,30.373,0,0,0,3.2-2.2Z",
    transform: "translate(-136.473 -36.091)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6210",
    "data-name": "Path 6210",
    d: "M292.743,77.263a3.737,3.737,0,0,1-.82-.234l-2.272-.82-8.351-3h0l-2.155-1.932a13.165,13.165,0,0,0-2.413-1.9,7.835,7.835,0,0,0-3.08-.949,13.772,13.772,0,0,0-3.514.328c-4.778.8-10.014,1.909-15.471,3.174-5.071,1.171-9.92,2.342-14.347,3.514a9.815,9.815,0,0,0-3.057,1.171,7.413,7.413,0,0,0-2.2,2.026c-1.089,1.7-2.05,3.408-2.963,4.919h0l-8.116,6-2.237,1.616a5.682,5.682,0,0,1-.8.527,4.909,4.909,0,0,1,.726-.632l2.155-1.71,7.87-6.125v.07c.914-1.546,1.815-3.221,2.94-5a8.023,8.023,0,0,1,2.342-2.225,10.365,10.365,0,0,1,3.2-1.171c4.427-1.171,9.264-2.342,14.359-3.514,5.458-1.265,10.7-2.342,15.518-3.15a13.738,13.738,0,0,1,3.6-.293,8.2,8.2,0,0,1,3.279,1.031,13.316,13.316,0,0,1,2.483,1.991l2.12,1.956h-.07l8.292,3.174,2.237.89A5.741,5.741,0,0,1,292.743,77.263Z",
    transform: "translate(-136.543 -43.266)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6211",
    "data-name": "Path 6211",
    d: "M245.059,76.158a5.481,5.481,0,0,1-.328-1.171c-.176-.761-.41-1.85-.691-3.209-.55-2.705-1.277-6.453-2.05-10.541-.363-2.073-.726-4.041-1.054-5.856-.152-.89-.293-1.745-.433-2.553a1.089,1.089,0,0,0-1.382-.89l-3.01,1.171a3.912,3.912,0,0,1-1.171.375,5.025,5.025,0,0,1,1.054-.586c.7-.351,1.675-.832,2.975-1.417a1.546,1.546,0,0,1,2,1.171c.164.808.328,1.663.5,2.553.34,1.8.7,3.771,1.1,5.856.761,4.146,1.417,7.905,1.862,10.634.223,1.359.4,2.471.5,3.232a4.076,4.076,0,0,1,.117,1.23Z",
    transform: "translate(-134.148 -46.096)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6212",
    "data-name": "Path 6212",
    d: "M258.334,72.922a16.1,16.1,0,0,1-1.23-3.385c-.644-2.132-1.382-5.106-2.167-8.4s-1.452-6.289-1.909-8.456a20.3,20.3,0,0,1-.609-3.514,21.491,21.491,0,0,1,1.031,3.514c.562,2.143,1.3,5.118,2.085,8.409s1.441,6.09,1.991,8.433a29.282,29.282,0,0,1,.808,3.4Z",
    transform: "translate(-131.156 -46.478)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6213",
    "data-name": "Path 6213",
    d: "M282.489,114.13a18.845,18.845,0,0,0,6.957-1.663,14.921,14.921,0,0,0,6.008-4.685,11.278,11.278,0,0,0,1.476-8.995,11.805,11.805,0,0,0-5.294-7.472,74.1,74.1,0,0,0-7.168-3.127,12.191,12.191,0,0,1-4.322-3.139,6.653,6.653,0,0,1-.808-1.171c-.141-.293-.211-.457-.187-.468a17.447,17.447,0,0,0,1.171,1.534,12.883,12.883,0,0,0,4.345,2.858,66.332,66.332,0,0,1,7.285,3.045,12.192,12.192,0,0,1,5.587,7.812,11.712,11.712,0,0,1-1.6,9.463,15.026,15.026,0,0,1-6.289,4.79,16.4,16.4,0,0,1-5.177,1.312,10.133,10.133,0,0,1-1.452,0A1.347,1.347,0,0,1,282.489,114.13Z",
    transform: "translate(-126.581 -40.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6214",
    "data-name": "Path 6214",
    d: "M207.492,107.519s-.105,0-.269-.2a5.141,5.141,0,0,1-.644-.7,7.308,7.308,0,0,1-1.323-3.221,7.742,7.742,0,0,1,.925-5.095,7.648,7.648,0,0,1,11.349-1.71,7.742,7.742,0,0,1,2.4,4.579,7.438,7.438,0,0,1-.316,3.514,4.18,4.18,0,0,1-.41.855c-.105.187-.176.281-.187.269s.164-.422.363-1.171a7.882,7.882,0,0,0,.129-3.338,7.46,7.46,0,0,0-2.342-4.228,7.2,7.2,0,0,0-10.541,1.581,7.531,7.531,0,0,0-.984,4.685,7.858,7.858,0,0,0,1.1,3.139A10.779,10.779,0,0,1,207.492,107.519Z",
    transform: "translate(-139.247 -38.667)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6215",
    "data-name": "Path 6215",
    d: "M241.938,144.781a1.6,1.6,0,0,1-.492.176c-.328.105-.808.223-1.441.375a32.15,32.15,0,0,1-5.434.808,17.767,17.767,0,0,1-8.046-1.241,15.53,15.53,0,0,1-7.238-6.816,20.3,20.3,0,0,1-2.448-9.662,28.576,28.576,0,0,1,1.171-8.069,37.766,37.766,0,0,1,1.921-5.13c.269-.586.492-1.042.656-1.335a2.027,2.027,0,0,1,.269-.445,16.174,16.174,0,0,1-.7,1.874,45.6,45.6,0,0,0-1.722,5.153,29.151,29.151,0,0,0-1.066,7.941,19.91,19.91,0,0,0,2.424,9.369,15.05,15.05,0,0,0,6.922,6.594,17.907,17.907,0,0,0,7.882,1.347,38.072,38.072,0,0,0,5.4-.609,15.13,15.13,0,0,1,1.944-.328Z",
    transform: "translate(-137.246 -35.476)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6216",
    "data-name": "Path 6216",
    d: "M219.708,118.5a1.662,1.662,0,0,1-.141.55,6.452,6.452,0,0,1-.75,1.487,8.819,8.819,0,0,1-4.907,3.514,8.713,8.713,0,0,1-4.216.187,10.435,10.435,0,0,1-4.4-2.061,11.876,11.876,0,0,1-3.35-4.181,13.34,13.34,0,0,1-1.241-5.622,16.139,16.139,0,0,1,3.654-10.295,10.213,10.213,0,0,1,7.894-4.005,8.081,8.081,0,0,1,5.587,2.2,4.591,4.591,0,0,1,1.253,1.827,10.845,10.845,0,0,0-1.405-1.651,8.081,8.081,0,0,0-5.434-1.944,9.826,9.826,0,0,0-7.46,3.923,15.776,15.776,0,0,0-3.514,9.943,12.88,12.88,0,0,0,1.17,5.361,11.56,11.56,0,0,0,3.163,4.008,10.225,10.225,0,0,0,4.146,2,8.538,8.538,0,0,0,4.017-.117,8.877,8.877,0,0,0,4.825-3.209,13.761,13.761,0,0,0,1.113-1.921Z",
    transform: "translate(-140.009 -38.107)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18218",
    "data-name": "Rectangle 18218",
    width: 415.289,
    height: 274.63,
    rx: 14.57,
    transform: "translate(16.233 206.97)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6217",
    "data-name": "Path 6217",
    d: "M148.88,442.94H598.813v3.186a20.847,20.847,0,0,1-20.847,20.847H169.727a20.847,20.847,0,0,1-20.847-20.847V442.94Z",
    transform: "translate(-148.88 20.929)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18219",
    "data-name": "Rectangle 18219",
    width: 391.831,
    height: 231.917,
    transform: "translate(27.382 217.885)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6218",
    "data-name": "Path 6218",
    d: "M305.08,440.74l5.587,8.878h78.563l5.188-8.878Z",
    transform: "translate(-122.141 20.552)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18220",
    "data-name": "Rectangle 18220",
    width: 376.5,
    height: 223.321,
    rx: 3.27,
    transform: "translate(35.452 225.732)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6219",
    "data-name": "Path 6219",
    d: "M555.3,460.83H178.81l.4-206.96H555.3Z",
    transform: "translate(-143.756 -11.437)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6220",
    "data-name": "Path 6220",
    d: "M206.39,247.44a3,3,0,1,1-.874-2.128,3.01,3.01,0,0,1,.874,2.128Z",
    transform: "translate(-140.066 -13.053)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6221",
    "data-name": "Path 6221",
    d: "M190.88,247.44a3,3,0,1,1-.874-2.128,3.01,3.01,0,0,1,.874,2.128Z",
    transform: "translate(-142.721 -13.053)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6222",
    "data-name": "Path 6222",
    d: "M198.3,247.44a3.01,3.01,0,1,1-3-3.01,3.01,3.01,0,0,1,3,3.01Z",
    transform: "translate(-141.451 -13.053)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6223",
    "data-name": "Path 6223",
    d: "M574.457,440.779c0,.152-92.172.269-205.847.269s-205.87-.117-205.87-.269,92.16-.269,205.87-.269S574.457,440.627,574.457,440.779Z",
    transform: "translate(-146.507 20.513)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6224",
    "data-name": "Path 6224",
    d: "M395.662,396.135c0,.164-22.58.3-50.431.3s-50.431-.141-50.431-.3,22.58-.3,50.431-.3S395.662,396.029,395.662,396.135Z",
    transform: "translate(-123.901 12.864)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18221",
    "data-name": "Rectangle 18221",
    width: 112.352,
    height: 84.442,
    transform: "translate(44.154 355.956)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6225",
    "data-name": "Path 6225",
    d: "M186.62,430.628,225.808,378.1l24.337,32.817,16.479-17.568,32.348,37.173Z",
    transform: "translate(-142.42 9.829)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6226",
    "data-name": "Path 6226",
    d: "M252.225,373.871a8.831,8.831,0,1,1-2.595-6.253,8.842,8.842,0,0,1,2.595,6.253Z",
    transform: "translate(-134.216 7.593)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18222",
    "data-name": "Rectangle 18222",
    width: 112.352,
    height: 84.442,
    transform: "translate(286.577 356.085)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6227",
    "data-name": "Path 6227",
    d: "M393.6,430.738l39.2-52.528,24.337,32.817L473.6,393.459l32.348,37.173Z",
    transform: "translate(-106.988 9.848)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6228",
    "data-name": "Path 6228",
    d: "M459.218,373.982a8.854,8.854,0,1,1-8.854-8.842A8.854,8.854,0,0,1,459.218,373.982Z",
    transform: "translate(-98.787 7.611)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6229",
    "data-name": "Path 6229",
    d: "M474.32,337.67a15.941,15.941,0,0,1,3.151-.211c1.944,0,4.685-.094,7.6-.094h3.3l-.293.293c0-2.167.059-4.029.117-5.352a8.735,8.735,0,0,1,.176-2.1,9.043,9.043,0,0,1,.187,2.1c0,1.323.082,3.186.105,5.352v.293h-3.6c-2.963,0-5.657,0-7.6-.094a15.935,15.935,0,0,1-3.15-.187Z",
    transform: "translate(-93.17 1.631)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6230",
    "data-name": "Path 6230",
    d: "M450.32,336.624a81.234,81.234,0,0,1,14.054,0,81.234,81.234,0,0,1-14.054,0Z",
    transform: "translate(-97.279 2.677)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6231",
    "data-name": "Path 6231",
    d: "M426.32,336.624a81.235,81.235,0,0,1,14.054,0,81.234,81.234,0,0,1-14.054,0Z",
    transform: "translate(-101.387 2.677)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6232",
    "data-name": "Path 6232",
    d: "M402.32,336.624a81.235,81.235,0,0,1,14.054,0,81.234,81.234,0,0,1-14.054,0Z",
    transform: "translate(-105.496 2.677)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6233",
    "data-name": "Path 6233",
    d: "M378.32,336.624a81.241,81.241,0,0,1,14.054,0,81.232,81.232,0,0,1-14.054,0Z",
    transform: "translate(-109.604 2.677)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6234",
    "data-name": "Path 6234",
    d: "M354.32,336.624a81.241,81.241,0,0,1,14.054,0,81.232,81.232,0,0,1-14.054,0Z",
    transform: "translate(-113.712 2.677)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6235",
    "data-name": "Path 6235",
    d: "M330.32,336.624a81.241,81.241,0,0,1,14.054,0,81.232,81.232,0,0,1-14.054,0Z",
    transform: "translate(-117.821 2.677)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6236",
    "data-name": "Path 6236",
    d: "M306.32,336.624a81.241,81.241,0,0,1,14.054,0,81.232,81.232,0,0,1-14.054,0Z",
    transform: "translate(-121.929 2.677)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6237",
    "data-name": "Path 6237",
    d: "M282.32,336.63a41.372,41.372,0,0,1,7.027-.3,41.245,41.245,0,0,1,7.027.3,41.249,41.249,0,0,1-7.027.3A41.368,41.368,0,0,1,282.32,336.63Z",
    transform: "translate(-126.037 2.672)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6238",
    "data-name": "Path 6238",
    d: "M258.32,336.63a41.371,41.371,0,0,1,7.027-.3,41.245,41.245,0,0,1,7.027.3,41.248,41.248,0,0,1-7.027.3A41.368,41.368,0,0,1,258.32,336.63Z",
    transform: "translate(-130.146 2.672)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6239",
    "data-name": "Path 6239",
    d: "M234.32,336.63a41.371,41.371,0,0,1,7.027-.3,41.246,41.246,0,0,1,7.027.3,41.249,41.249,0,0,1-7.027.3A41.368,41.368,0,0,1,234.32,336.63Z",
    transform: "translate(-134.254 2.672)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6240",
    "data-name": "Path 6240",
    d: "M210.32,336.63a41.372,41.372,0,0,1,7.027-.3,41.246,41.246,0,0,1,7.027.3,41.249,41.249,0,0,1-7.027.3A41.365,41.365,0,0,1,210.32,336.63Z",
    transform: "translate(-138.363 2.672)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6241",
    "data-name": "Path 6241",
    d: "M186.34,336.618h0a43.021,43.021,0,0,1,7.027-.293,41.249,41.249,0,0,1,7.027.3,41.242,41.242,0,0,1-7.027.3,43.025,43.025,0,0,1-7.027-.293h0Z",
    transform: "translate(-142.467 2.672)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6242",
    "data-name": "Path 6242",
    d: "M186.385,312.57a81.232,81.232,0,0,1,0,14.054A81.232,81.232,0,0,1,186.385,312.57Z",
    transform: "translate(-142.512 -1.388)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6243",
    "data-name": "Path 6243",
    d: "M186.39,288.57a41.248,41.248,0,0,1,.3,7.027,41.37,41.37,0,0,1-.3,7.027,39.964,39.964,0,0,1-.3-7.027,39.82,39.82,0,0,1,.3-7.027Z",
    transform: "translate(-142.518 -5.497)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6244",
    "data-name": "Path 6244",
    d: "M186.39,264.57a41.249,41.249,0,0,1,.3,7.027,41.37,41.37,0,0,1-.3,7.027,39.964,39.964,0,0,1-.3-7.027,39.821,39.821,0,0,1,.3-7.027Z",
    transform: "translate(-142.518 -9.605)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6245",
    "data-name": "Path 6245",
    d: "M209.214,261.44a41.365,41.365,0,0,1-7.027.3,41.246,41.246,0,0,1-7.027-.3,39.815,39.815,0,0,1,7.027-.3,39.962,39.962,0,0,1,7.027.3Z",
    transform: "translate(-140.958 -10.2)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6246",
    "data-name": "Path 6246",
    d: "M233.214,261.44a41.365,41.365,0,0,1-7.027.3,41.246,41.246,0,0,1-7.027-.3,39.815,39.815,0,0,1,7.027-.3A39.961,39.961,0,0,1,233.214,261.44Z",
    transform: "translate(-136.849 -10.2)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6247",
    "data-name": "Path 6247",
    d: "M257.214,261.44a41.365,41.365,0,0,1-7.027.3,41.246,41.246,0,0,1-7.027-.3,39.815,39.815,0,0,1,7.027-.3A39.961,39.961,0,0,1,257.214,261.44Z",
    transform: "translate(-132.741 -10.2)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6248",
    "data-name": "Path 6248",
    d: "M281.214,261.44a41.364,41.364,0,0,1-7.027.3,41.245,41.245,0,0,1-7.027-.3,39.815,39.815,0,0,1,7.027-.3A39.961,39.961,0,0,1,281.214,261.44Z",
    transform: "translate(-128.633 -10.2)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6249",
    "data-name": "Path 6249",
    d: "M305.214,261.44a81.235,81.235,0,0,1-14.054,0,39.814,39.814,0,0,1,7.027-.3A39.962,39.962,0,0,1,305.214,261.44Z",
    transform: "translate(-124.524 -10.2)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6250",
    "data-name": "Path 6250",
    d: "M329.214,261.435a81.235,81.235,0,0,1-14.054,0,81.226,81.226,0,0,1,14.054,0Z",
    transform: "translate(-120.416 -10.194)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6251",
    "data-name": "Path 6251",
    d: "M353.214,261.435a81.235,81.235,0,0,1-14.054,0,81.226,81.226,0,0,1,14.054,0Z",
    transform: "translate(-116.307 -10.194)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6252",
    "data-name": "Path 6252",
    d: "M377.214,261.435a81.234,81.234,0,0,1-14.054,0,81.226,81.226,0,0,1,14.054,0Z",
    transform: "translate(-112.199 -10.194)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6253",
    "data-name": "Path 6253",
    d: "M401.214,261.435a81.235,81.235,0,0,1-14.054,0A81.223,81.223,0,0,1,401.214,261.435Z",
    transform: "translate(-108.091 -10.194)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6254",
    "data-name": "Path 6254",
    d: "M425.214,261.435a81.235,81.235,0,0,1-14.054,0,81.223,81.223,0,0,1,14.054,0Z",
    transform: "translate(-103.982 -10.194)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6255",
    "data-name": "Path 6255",
    d: "M449.214,261.435a81.234,81.234,0,0,1-14.054,0A81.225,81.225,0,0,1,449.214,261.435Z",
    transform: "translate(-99.874 -10.194)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6256",
    "data-name": "Path 6256",
    d: "M473.214,261.435a81.234,81.234,0,0,1-14.054,0,81.226,81.226,0,0,1,14.054,0Z",
    transform: "translate(-95.766 -10.194)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6257",
    "data-name": "Path 6257",
    d: "M486.866,271.773a41.364,41.364,0,0,1-.3-7.027v-3.314l.269.269a16.85,16.85,0,0,1-3.7-.269,16.009,16.009,0,0,1,3.7-.269h.269v3.6a39.964,39.964,0,0,1-.234,7.015Z",
    transform: "translate(-91.662 -10.191)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6258",
    "data-name": "Path 6258",
    d: "M486.37,296.274a41.365,41.365,0,0,1-.3-7.027,41.366,41.366,0,0,1,.3-7.027,39.97,39.97,0,0,1,.3,7.027A39.97,39.97,0,0,1,486.37,296.274Z",
    transform: "translate(-91.166 -6.584)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6259",
    "data-name": "Path 6259",
    d: "M486.365,320.274a81.234,81.234,0,0,1,0-14.054A81.234,81.234,0,0,1,486.365,320.274Z",
    transform: "translate(-91.161 -2.475)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6260",
    "data-name": "Path 6260",
    d: "M395.662,420.445c0,.176-22.58.3-50.431.3s-50.431-.129-50.431-.3,22.58-.3,50.431-.3S395.662,420.281,395.662,420.445Z",
    transform: "translate(-123.901 17.026)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6261",
    "data-name": "Path 6261",
    d: "M395.662,409.325c0,.164-22.58.3-50.431.3s-50.431-.141-50.431-.3,22.58-.3,50.431-.3S395.662,409.161,395.662,409.325Z",
    transform: "translate(-123.901 15.122)",
    fill: "#e0e0e0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-34",
    transform: "translate(91.013 306.169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18223",
    "data-name": "Rectangle 18223",
    width: 6.067,
    height: 163.649,
    transform: "translate(32.243 64.72)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_338",
    "data-name": "Ellipse 338",
    cx: 35.276,
    cy: 35.276,
    r: 35.276,
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6262",
    "data-name": "Path 6262",
    d: "M151.018,302.676a2.565,2.565,0,0,1-.059-.515,8.578,8.578,0,0,0-.105-1.5,6.3,6.3,0,0,0-.07-1.113c-.07-.41-.141-.843-.211-1.323a21.912,21.912,0,0,0-.668-3.268,30.206,30.206,0,0,0-3.514-8.409,31.752,31.752,0,0,0-8.034-8.936,31.411,31.411,0,0,0-29.807-4.5,32.517,32.517,0,0,0-4.1,1.8c-.668.363-1.312.785-1.968,1.171a17.121,17.121,0,0,0-1.9,1.312,36.123,36.123,0,0,0-3.514,3.033,34.425,34.425,0,0,0-3.092,3.654,30.452,30.452,0,0,0-4.486,8.667,33.39,33.39,0,0,0-1.687,9.92,33.823,33.823,0,0,0,1.616,9.92,30.544,30.544,0,0,0,4.5,8.678A36.932,36.932,0,0,0,97,324.928a36.314,36.314,0,0,0,3.572,3.033,17.122,17.122,0,0,0,1.9,1.312c.656.386,1.3.808,1.968,1.171a30.909,30.909,0,0,0,4.1,1.8,31.552,31.552,0,0,0,37.841-13.433,30.017,30.017,0,0,0,3.514-8.4,22.028,22.028,0,0,0,.668-3.279c.082-.468.164-.914.211-1.323s0-.773.07-1.1q.07-.972.105-1.511a2.564,2.564,0,0,1,.059-.515,2.857,2.857,0,0,1,0,.515v2.682a12.74,12.74,0,0,1-.176,1.335,23.515,23.515,0,0,1-.621,3.3,30.286,30.286,0,0,1-3.514,8.514,31.829,31.829,0,0,1-38.321,13.785A32.929,32.929,0,0,1,104.182,331c-.668-.363-1.323-.785-1.991-1.171a16.67,16.67,0,0,1-1.956-1.382,34.732,34.732,0,0,1-3.642-3.08,36.875,36.875,0,0,1-3.15-3.713,31.352,31.352,0,0,1-4.591-8.831,31.833,31.833,0,0,1,0-20.238,31.353,31.353,0,0,1,4.591-8.831,36.956,36.956,0,0,1,3.15-3.7,34.851,34.851,0,0,1,3.642-3.139,15.229,15.229,0,0,1,1.932-1.323c.668-.4,1.323-.832,1.991-1.171a34.693,34.693,0,0,1,4.193-1.827A31.884,31.884,0,0,1,146.7,286.4a30.205,30.205,0,0,1,3.514,8.526,23.213,23.213,0,0,1,.621,3.3c.059.48.141.925.176,1.335s0,.773,0,1.171v1.511a2.859,2.859,0,0,1,.012.433Z",
    transform: "translate(-83.979 -267.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18224",
    "data-name": "Rectangle 18224",
    width: 36.74,
    height: 7.66,
    transform: "translate(16.912 30.872)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-34",
    transform: "translate(255.377 83.932)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18225",
    "data-name": "Rectangle 18225",
    width: 344.726,
    height: 100.078,
    transform: "matrix(0.997, -0.08, 0.08, 0.997, 0.251, 239.872)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6263",
    "data-name": "Path 6263",
    d: "M576.7,359.519c-.117-1.441-3.033-36.881-8.2-99.738l.2.176-343.59,27.722h0l.269-.328c2.764,34.433,5.458,67.929,8.011,99.75l-.316-.269,245.6-19.594,98.028-7.718-1.675.152-4.966.422-19.266,1.581-71.9,5.856L233.105,387.44h-.293v-.3c-2.565-31.8-5.259-65.317-8.023-99.75v-.3h.3L568.661,259.57h.2v.187C573.8,322.626,576.59,358.078,576.7,359.519Z",
    transform: "translate(-224.79 -47.521)",
    fill: "#263238"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18226",
    "data-name": "Rectangle 18226",
    width: 108.776,
    height: 81.761,
    transform: "translate(9.682 250.022) rotate(-4.004)",
    fill: "#f30813"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6264",
    "data-name": "Path 6264",
    d: "M441.939,345.815a41.657,41.657,0,0,1-7.027.89l-.328-.281h0V345.03c0-.445-.07-.878-.094-1.312,0-.773-.082-1.511-.129-2.237a7.144,7.144,0,0,1,0-2.061,7.026,7.026,0,0,1,.386,2.026c.082.714.164,1.452.258,2.225,0,.422.082.867.117,1.312l.07.691v.691h0l-.328-.281A42.066,42.066,0,0,1,441.939,345.815Z",
    transform: "translate(-188.928 -33.852)",
    fill: "#e0e0e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6265",
    "data-name": "Path 6265",
    d: "M470.323,342.594a54.085,54.085,0,0,1-7.917.972,50.361,50.361,0,0,1-7.976.363,54.085,54.085,0,0,1,7.917-.972A50.358,50.358,0,0,1,470.323,342.594Z",
    transform: "translate(-185.48 -33.314)",
    fill: "#e0e0e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6266",
    "data-name": "Path 6266",
    d: "M497.423,340.3a54.082,54.082,0,0,1-7.917.972,52.055,52.055,0,0,1-7.976.363,54.086,54.086,0,0,1,7.917-.972,50.353,50.353,0,0,1,7.976-.363Z",
    transform: "translate(-180.841 -33.706)",
    fill: "#e0e0e0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6267",
    "data-name": "Path 6267",
    d: "M515.076,332.67a39.29,39.29,0,0,1,.9,6.969c-.562.668-.164.187-.281.34H514.28l-1.312.094-2.225.129a7.249,7.249,0,0,1-2.073,0,7.24,7.24,0,0,1,2.038-.386l2.214-.258,1.312-.129.7-.059h.7c-.117.141.281-.328-.269.328A41.416,41.416,0,0,1,515.076,332.67Z",
    transform: "translate(-176.195 -35.008)",
    fill: "#e0e0e0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6268",
    "data-name": "Path 6268",
    d: "M512.255,310.28a69.75,69.75,0,0,1,1.171,13.106,35.9,35.9,0,0,1-.855-6.523,36.794,36.794,0,0,1-.316-6.582Z",
    transform: "translate(-175.587 -38.841)",
    fill: "#e0e0e0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6269",
    "data-name": "Path 6269",
    d: "M510.367,287.9a35.246,35.246,0,0,1,.867,6.523,36.077,36.077,0,0,1,.246,6.582,34.947,34.947,0,0,1-.855-6.535A36.657,36.657,0,0,1,510.367,287.9Z",
    transform: "translate(-175.912 -42.672)",
    fill: "#e0e0e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6270",
    "data-name": "Path 6270",
    d: "M502.93,271.36a41.905,41.905,0,0,1,7.027-.89l.328.281h0v1.394c0,.445.059.878.094,1.312,0,.773.082,1.511.117,2.237a6.943,6.943,0,0,1,0,2.061,7.029,7.029,0,0,1-.386-2.026c-.082-.714-.164-1.452-.258-2.225a13.077,13.077,0,0,0-.129-1.312l-.059-.691v-.691h0l.34.281a42.165,42.165,0,0,1-7.074.269Z",
    transform: "translate(-177.177 -45.655)",
    fill: "#e0e0e0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6271",
    "data-name": "Path 6271",
    d: "M475.8,273.719a53.5,53.5,0,0,1,7.917-.972,50.2,50.2,0,0,1,7.964-.363,53.5,53.5,0,0,1-7.917.972,50.177,50.177,0,0,1-7.964.363Z",
    transform: "translate(-181.822 -45.333)",
    fill: "#e0e0e0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6272",
    "data-name": "Path 6272",
    d: "M448.66,276.009a53.511,53.511,0,0,1,7.917-.972,52.042,52.042,0,0,1,7.976-.363,54.115,54.115,0,0,1-7.929.972A50.169,50.169,0,0,1,448.66,276.009Z",
    transform: "translate(-186.467 -44.94)",
    fill: "#e0e0e0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6273",
    "data-name": "Path 6273",
    d: "M429.74,284.558a41.385,41.385,0,0,1-.89-6.969c.55-.668.152-.187.281-.328h.714l.691-.059,1.312-.094,2.237-.129a7.251,7.251,0,0,1,2.073,0,7.377,7.377,0,0,1-2.038.387l-2.225.258-1.312.129-.691.059h-.714l.281-.328A39.256,39.256,0,0,1,429.74,284.558Z",
    transform: "translate(-189.859 -44.554)",
    fill: "#e0e0e0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6274",
    "data-name": "Path 6274",
    d: "M431.669,307.746a36.31,36.31,0,0,1-.855-6.535,34.75,34.75,0,0,1-.246-6.57,35.892,35.892,0,0,1,.855,6.524A34.85,34.85,0,0,1,431.669,307.746Z",
    transform: "translate(-189.574 -41.518)",
    fill: "#e0e0e0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6275",
    "data-name": "Path 6275",
    d: "M433.559,330.125a35.894,35.894,0,0,1-.855-6.523,34.853,34.853,0,0,1-.246-6.582,36.144,36.144,0,0,1,.855,6.535A34.73,34.73,0,0,1,433.559,330.125Z",
    transform: "translate(-189.251 -37.687)",
    fill: "#e0e0e0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6276",
    "data-name": "Path 6276",
    d: "M237.68,368.294l34.21-53.254,25.672,29.971,14.675-18.048L345.921,360.6Z",
    transform: "translate(-222.583 -38.026)",
    fill: "#f30813"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6277",
    "data-name": "Path 6277",
    d: "M297.5,308.88a8.55,8.55,0,1,1-9.135-7.917,8.55,8.55,0,0,1,9.135,7.917Z",
    transform: "translate(-215.267 -40.439)",
    fill: "#f30813"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10789",
    "data-name": "Group 10789",
    transform: "translate(15.097 277.014)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6278",
    "data-name": "Path 6278",
    d: "M237.68,368.294l34.21-53.254,25.672,29.971,14.675-18.048L345.921,360.6Z",
    transform: "translate(-237.68 -315.04)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10790",
    "data-name": "Group 10790",
    transform: "translate(65.151 260.503)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6279",
    "data-name": "Path 6279",
    d: "M297.5,308.88a8.55,8.55,0,1,1-9.135-7.917,8.55,8.55,0,0,1,9.135,7.917Z",
    transform: "translate(-280.418 -300.942)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6280",
    "data-name": "Path 6280",
    d: "M435.256,296.442c0,.176-21.023,2.249-46.988,4.685s-47.035,4.2-47.058,4.029,21.081-2.237,47-4.685S435.244,296.278,435.256,296.442Z",
    transform: "translate(-204.861 -41.211)",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6281",
    "data-name": "Path 6281",
    d: "M437.74,309.8c0,.176-21.269,2.272-47.515,4.685s-47.562,4.251-47.585,4.087,21.257-2.272,47.527-4.685S437.717,309.638,437.74,309.8Z",
    transform: "translate(-204.616 -38.924)",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6282",
    "data-name": "Path 6282",
    d: "M440.2,323.172c0,.164-21.491,2.284-48.018,4.685s-48.018,4.3-48.018,4.134,21.479-2.284,48.018-4.743S440.185,322.973,440.2,323.172Z",
    transform: "translate(-204.356 -36.636)",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6283",
    "data-name": "Path 6283",
    d: "M440.7,336.411c0,.176-21.515,2.342-48.077,4.755s-48.136,4.3-48.147,4.134,21.515-2.342,48.089-4.743S440.693,336.247,440.7,336.411Z",
    transform: "translate(-204.301 -34.369)",
    fill: "#263238"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18227",
    "data-name": "Rectangle 18227",
    width: 49.67,
    height: 3.935,
    transform: "matrix(0.997, -0.08, 0.08, 0.997, 134.228, 248.877)",
    fill: "#f30813"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6284",
    "data-name": "Path 6284",
    d: "M473.153,322.286c-.164,0-.808-5.762-1.429-12.883s-.984-12.942-.808-12.953.8,5.762,1.417,12.883S473.364,322.275,473.153,322.286Z",
    transform: "translate(-182.665 -41.208)",
    fill: "#e0e0e0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6285",
    "data-name": "Path 6285",
    d: "M485.694,306.948c0,.164-5.551.656-12.414,1.089s-12.45.656-12.45.492a122.067,122.067,0,0,1,12.414-1.1C480.108,307.018,485.682,306.784,485.694,306.948Z",
    transform: "translate(-184.384 -39.42)",
    fill: "#e0e0e0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6286",
    "data-name": "Path 6286",
    d: "M568.64,269.029s-.281-.082-.832-.293l-2.342-.914-9.229-3.584L522.12,250.875l-113.933-44.9h.246l-14.417,7.156-119.461,59.18-36.213,17.861-9.838,4.825-2.577,1.241c-.574.281-.878.41-.878.41l.855-.468,2.541-1.288,9.815-4.931L274.4,271.91,393.77,212.566l14.417-7.156h.246L522.3,250.489l33.964,13.539,9.182,3.689,2.342.972Z",
    transform: "translate(-224.745 -56.793)",
    fill: "#263238"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6287",
    "data-name": "Path 6287",
    d: "M462.549,120.672a7.835,7.835,0,0,0-14.23-.094l-12.239,1.007,12.368,24.4,7.753-14.265a7.472,7.472,0,0,0,2.46-.668,7.835,7.835,0,0,0,3.888-10.377Z",
    transform: "translate(-188.621 -72.086)",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6288",
    "data-name": "Path 6288",
    d: "M402.118,91.574l7.987-3.408-19.266-4.849a7.835,7.835,0,1,0-1.815,10.435l18.294,11.2Z",
    transform: "translate(-198.836 -78.31)",
    fill: "#263238"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6289",
    "data-name": "Path 6289",
    d: "M552.478,330.551v-.164L420.263,83.924l-.75-1.394-20.824,9.5,99.7,262.766.059.164,59.379,94.386,1.171-.176,1.37-.2,1.078-.164-12.286-19.524,7.179-18.493,19.008,7.027,8.374,27.7,1-.141,1.265-.187,1.171-.164Zm8.55,39.926-23.728-6.09,13.761-26.879ZM535.2,363.848l-29.186-7.5,43.076-19.629Zm11.021-37.9L515.9,317.563,528.34,292.6ZM513.829,317l-26.691-7.378,39.293-17.907Zm10.81-31.306-27.944-9.744,9.967-23.775ZM494.7,275.26,470.109,266.7l34.772-15.834Zm8-30.451-25.426-10.986,7.531-22.393Zm-27.371-11.817-21.784-9.369L483,210.2Zm5.856-28.354-.141.07L458.174,192.34l5.083-21.14ZM458.631,162.6l-19.91-13.4,2.635-18.879Zm-21.9-14.71L420.7,137.119l18.739-8.538ZM419.736,90.108l16.935,31.622-17.415-14.675ZM416.5,129.494l-12.3-32.36L417.089,108Zm.691-24.22L403.363,93.621l14.347-6.535Zm1.979,4.439,16.76,14.054L418.542,131.7Zm1.089,29.678,16.151,10.845-3.256,23.178Zm18.095,12.157,19.406,13.035-22.686,10.33Zm23.154,17.7-5.294,22.03L436.531,180.6Zm-24.595,13.984,18.809,10.166-5.8,24.126Zm20.73,11.208,20.976,11.337-26.644,12.11Zm-4.685,31.177,21.679,9.369-8.514,25.333Zm23.623,10.2,24.3,10.541-32.875,14.968Zm-7.308,32.793,24.595,8.573-11.2,26.738Zm26.6,9.276,26.609,9.276L484.8,304.317ZM485.5,311.367l27.382,7.566-13.914,27.921ZM515,319.5l29.76,8.2-43.8,19.91Zm-10.541,38.649L534.3,365.8,523.07,387.728Zm31.938,8.2,24.279,6.231L524.7,388.97Zm11.454,60.784-15.94-25.344,22.534,8.351Zm7.355-18.961L530.073,398.8l-.621-.972,35.135-15.987.363,1.171Zm1.979.726,8.667-22.475,8.76,28.975Z",
    transform: "translate(-195.021 -77.827)",
    fill: "#263238"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6290",
    "data-name": "Path 6290",
    d: "M381.376,200.874V192.7c0-5.352,0-13.223-.07-23.307,0-20.179-.059-49.19-.105-84.676v-.223h.223l37.021-3.923h.129l.094.105L515.23,188.6,655.772,345.913l42.584,47.7,11.548,13L712.891,410c.668.761,1.007,1.171,1.007,1.171s-.363-.375-1.054-1.171-1.71-1.874-3.033-3.35c-2.67-2.951-6.582-7.308-11.63-12.883l-42.678-47.6L514.785,189,418.28,81.074l.223.094-37.1,3.841.211-.234c0,35.463-.07,64.5-.105,84.676v29.4A11.3,11.3,0,0,1,381.376,200.874Z",
    transform: "translate(-198.015 -78.163)",
    fill: "#263238"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18228",
    "data-name": "Rectangle 18228",
    width: 5.926,
    height: 12.707,
    rx: 0.38,
    transform: "translate(180.011 89.625)",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6291",
    "data-name": "Path 6291",
    d: "M392.77,168.2H373.317a2.167,2.167,0,0,1-2.167-2.167h0a2.167,2.167,0,0,1,2.167-2.167h19.465a2.167,2.167,0,0,1,2.167,2.167h0a2.167,2.167,0,0,1-2.178,2.167Z",
    transform: "translate(-199.736 -63.903)",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6292",
    "data-name": "Path 6292",
    d: "M383.606,197.7l-.07-2.776-2.869,1.265a15.912,15.912,0,0,0,0,3.08,1.311,1.311,0,0,0,.105.48,1.382,1.382,0,0,0,.7.48,5.61,5.61,0,0,1,2.94,2.577,3.385,3.385,0,0,1-1.932,4.685,3.514,3.514,0,0,1-4.38-2.342c0-.48,0-1.171-.656-1.171-.949-.094-1.359,1.288-1.335,2.014.152,4.2,4.111,5.54,5.786,5.6a6.09,6.09,0,0,0,3.279-.7,6.348,6.348,0,0,0,3.069-4.345C389.157,201.01,383.313,198.047,383.606,197.7Z",
    transform: "translate(-198.887 -58.588)",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6293",
    "data-name": "Path 6293",
    d: "M387.572,201.314,400.01,171.39a4.111,4.111,0,0,0-3.795-5.68H371.351a4.1,4.1,0,0,0-3.795,5.68l12.426,29.924a4.111,4.111,0,0,0,7.589,0Z",
    transform: "translate(-200.405 -63.588)",
    fill: "#e0e0e0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6294",
    "data-name": "Path 6294",
    d: "M372.3,167.52l-3.221,3.209a.79.79,0,0,0,.059.363l1.054,2.53,6.1-6.1Z",
    transform: "translate(-200.09 -63.279)",
    fill: "#f30813"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6295",
    "data-name": "Path 6295",
    d: "M383.972,167.52h-4.005l-8.936,8.936,1.183,2.823Z",
    transform: "translate(-199.756 -63.279)",
    fill: "#f30813"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6296",
    "data-name": "Path 6296",
    d: "M391.491,181.72l2.834-6.84L377.05,192.155l1.171,2.823Z",
    transform: "translate(-198.726 -62.019)",
    fill: "#f30813"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6297",
    "data-name": "Path 6297",
    d: "M388.351,186.57l-9.241,9.241.3.75A2.506,2.506,0,0,0,380.925,198l4.579-4.591Z",
    transform: "translate(-198.373 -60.018)",
    fill: "#f30813"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6298",
    "data-name": "Path 6298",
    d: "M391.627,167.52h-3.994L373.04,182.1l1.171,2.834Z",
    transform: "translate(-199.412 -63.279)",
    fill: "#f30813"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6299",
    "data-name": "Path 6299",
    d: "M396.96,169.825a2.413,2.413,0,0,0-1.839-2.155L375,187.732l1.171,2.834Z",
    transform: "translate(-199.077 -63.253)",
    fill: "#f30813"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6300",
    "data-name": "Path 6300",
    d: "M655.222,357.34h20.894a3.092,3.092,0,0,1,3.092,3.092v9.533H652.13v-9.51a3.092,3.092,0,0,1,3.092-3.115Z",
    transform: "translate(-151.637 -30.785)",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6301",
    "data-name": "Path 6301",
    d: "M612.379,370.825H607.94v-26.4a11.429,11.429,0,0,1,.539-3.443l2.237-6.91a.164.164,0,0,1,.293,0l2.612,4.685-.691,2.143a11.6,11.6,0,0,0-.55,3.514Z",
    transform: "translate(-159.202 -34.783)",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6302",
    "data-name": "Path 6302",
    d: "M738.215,373.756a9.662,9.662,0,0,0-7.25-5.856l-111.028-.059V349.4a4.486,4.486,0,0,0-4.5-4.486H561.788a4.485,4.485,0,0,0-4.275,3.115l-1.6,5.083h5.973a4.685,4.685,0,0,1,3.584,1.663,4.4,4.4,0,0,1,.937,3.748l-5.739,27.23a4.685,4.685,0,0,1-4.532,3.6h-11.4a17.951,17.951,0,0,0,.3,5.188l.632,2.729L516.3,403.036a1.23,1.23,0,0,0-.96.937l-2.764,7.425a4.507,4.507,0,0,0-.4,1.066h0c-.586,2.448-.152,6.547,1.323,6.547h31.47l-1.335,1.593-1.78,5.528H741.764C741.811,408.259,741.342,381.322,738.215,373.756ZM599.652,356.868l-2.951,26.8a5.812,5.812,0,0,1-.152,1.007,11.782,11.782,0,0,1-11.712,9.205H571.649a4.064,4.064,0,0,1-3.97-4.919l6.207-32.161a4.521,4.521,0,0,1,4.415-3.607h18.036a3.385,3.385,0,0,1,3.361,3.76Z",
    transform: "translate(-175.638 -32.913)",
    fill: "#f30813"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6303",
    "data-name": "Path 6303",
    d: "M641.471,427.324,556.384,428.5c-.55,0-1.534-1.64-1.534-2.19v-9.5a1.007,1.007,0,0,1,1.007-1.007h85.613a1,1,0,0,1,1,1.007v9.5a1,1,0,0,1-1,1.019Z",
    transform: "translate(-168.29 -20.778)",
    fill: "#455a64"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6304",
    "data-name": "Path 6304",
    d: "M591.513,355.661l-2.952,26.8a5.98,5.98,0,0,1-.152,1.007,11.712,11.712,0,0,1-11.712,9.194H563.534a4.076,4.076,0,0,1-3.97-4.931l6.207-32.161a4.532,4.532,0,0,1,4.415-3.607H588.2a3.4,3.4,0,0,1,3.361,3.771Z",
    transform: "translate(-167.498 -31.706)",
    fill: "#f30813"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10791",
    "data-name": "Group 10791",
    transform: "translate(391.974 320.254)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6305",
    "data-name": "Path 6305",
    d: "M737.468,416.553a4.451,4.451,0,0,0-.269-2.143H537.735a4.579,4.579,0,0,0-.281,2.143Z",
    transform: "translate(-563.246 -341.27)",
    fill: "#f30813",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6306",
    "data-name": "Path 6306",
    d: "M552.731,348.015l-12,37.3a17.852,17.852,0,0,0-.468,9.217L545.4,418.38h69.756V349.4a4.5,4.5,0,0,0-4.5-4.5H557.006A4.509,4.509,0,0,0,552.731,348.015Z",
    transform: "translate(-562.829 -353.169)",
    fill: "#f30813"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6308",
    "data-name": "Path 6308",
    d: "M563.534,392.6a4.064,4.064,0,0,1-3.97-4.919l6.207-32.161a4.521,4.521,0,0,1,4.415-3.607H588.2a3.373,3.373,0,0,1,2.518,1.171,3.408,3.408,0,0,1,.843,2.635l-3,26.75a5.806,5.806,0,0,1-.152,1.007,11.782,11.782,0,0,1-11.712,9.206Z",
    transform: "translate(-167.498 -31.714)",
    fill: "#455a64"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6309",
    "data-name": "Path 6309",
    d: "M539.94,388.2a16.794,16.794,0,0,1,.8-3.865L551.16,351.96h5.961a4.685,4.685,0,0,1,3.584,1.651,4.427,4.427,0,0,1,.949,3.759l-5.75,27.218a4.685,4.685,0,0,1-4.521,3.607Z",
    transform: "translate(-170.842 -31.706)",
    fill: "#455a64"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6310",
    "data-name": "Path 6310",
    d: "M737.688,419.578H537.837c-1.522,0-1.522-5.528,0-5.528H737.688C739.222,414.05,739.222,419.578,737.688,419.578Z",
    transform: "translate(-171.397 -21.077)",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6311",
    "data-name": "Path 6311",
    d: "M614.538,365.74v1.171c0,.808,0,1.921-.07,3.326-.094,2.94-.223,7.109-.375,12.239s-.4,11.337-.632,18.153c-.07,1.71-.129,3.514-.2,5.247a12.3,12.3,0,0,1-1.171,5.434,7.449,7.449,0,0,1-4.6,3.514,20.6,20.6,0,0,1-5.856.7l-40.417-.761-12.239-.3-3.326-.117h-.867a.924.924,0,0,1-.293,0,.784.784,0,0,1,.293,0h4.193l12.251.117,40.406.574a19.912,19.912,0,0,0,5.692-.656,6.852,6.852,0,0,0,4.251-3.162,11.711,11.711,0,0,0,1.171-5.177c.082-1.78.152-3.513.222-5.247.281-6.816.539-12.965.761-18.142s.433-9.3.574-12.239c.07-1.405.141-2.518.176-3.326a3.022,3.022,0,0,1,.07-.855A.819.819,0,0,1,614.538,365.74Z",
    transform: "translate(-170.063 -29.347)",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6312",
    "data-name": "Path 6312",
    d: "M555.714,411.706c-.176,0-.3-5.856-.3-13.082s.129-13.094.3-13.094.3,5.856.3,13.094S555.879,411.706,555.714,411.706Z",
    transform: "translate(-168.194 -25.959)",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6313",
    "data-name": "Path 6313",
    d: "M566.146,345.09a13.557,13.557,0,0,1-.222,1.886c-.176,1.171-.469,2.963-.855,5.118-.761,4.31-1.921,10.248-3.373,16.76s-2.951,12.391-4.1,16.607c-.574,2.12-1.054,3.818-1.417,4.989a10.365,10.365,0,0,1-.609,1.8,13.016,13.016,0,0,1,.387-1.862c.316-1.288.726-2.987,1.23-5.036,1.031-4.251,2.448-10.119,3.912-16.631s2.682-12.426,3.514-16.713l1.042-5.071a9.418,9.418,0,0,1,.492-1.851Z",
    transform: "translate(-168.166 -32.882)",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6314",
    "data-name": "Path 6314",
    d: "M585.993,396.452a3.779,3.779,0,0,0,1.089-.445,2.084,2.084,0,0,0,.75-1.089,2.342,2.342,0,0,0-.211-1.686,1.874,1.874,0,0,0-1.733-.914H577.15a1.815,1.815,0,0,0-1.78,1.675,1.851,1.851,0,0,0,1.171,2.026,1.675,1.675,0,0,0,.586.105h4.3c1.417,0,2.565.059,3.35.094a4.507,4.507,0,0,1,1.23.117,4.508,4.508,0,0,1-1.23.117c-.785,0-1.932.07-3.35.094H577.15a2.369,2.369,0,0,1-2.378-2.729,2.342,2.342,0,0,1,2.342-2.237h8.737a2.342,2.342,0,0,1,2.108,1.171,2.412,2.412,0,0,1,.281,1.066,2.578,2.578,0,0,1-.117.949,2.225,2.225,0,0,1-.949,1.171,1.85,1.85,0,0,1-.89.293C586.1,396.5,585.993,396.464,585.993,396.452Z",
    transform: "translate(-164.883 -24.924)",
    fill: "#f30813"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6315",
    "data-name": "Path 6315",
    d: "M702.424,371.245c0,.176-8.2.3-18.247.3s-18.247-.129-18.247-.3,8.2-.3,18.247-.3S702.424,371.081,702.424,371.245Z",
    transform: "translate(-149.275 -28.457)",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6316",
    "data-name": "Path 6316",
    d: "M702.424,374.344c0,.176-8.2.316-18.247.316s-18.247-.141-18.247-.316,8.2-.3,18.247-.3S702.424,374.181,702.424,374.344Z",
    transform: "translate(-149.275 -27.926)",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6317",
    "data-name": "Path 6317",
    d: "M702.424,377.455c0,.164-8.2.3-18.247.3s-18.247-.141-18.247-.3,8.2-.3,18.247-.3S702.424,377.279,702.424,377.455Z",
    transform: "translate(-149.275 -27.394)",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6318",
    "data-name": "Path 6318",
    d: "M702.424,380.554c0,.164-8.2.3-18.247.3s-18.247-.141-18.247-.3,8.2-.3,18.247-.3S702.424,380.379,702.424,380.554Z",
    transform: "translate(-149.275 -26.863)",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6319",
    "data-name": "Path 6319",
    d: "M702.424,383.654c0,.164-8.2.3-18.247.3s-18.247-.141-18.247-.3,8.2-.3,18.247-.3S702.424,383.479,702.424,383.654Z",
    transform: "translate(-149.275 -26.332)",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6320",
    "data-name": "Path 6320",
    d: "M702.424,386.755c0,.164-8.2.3-18.247.3s-18.247-.141-18.247-.3,8.2-.3,18.247-.3S702.424,386.579,702.424,386.755Z",
    transform: "translate(-149.275 -25.802)",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6321",
    "data-name": "Path 6321",
    d: "M702.424,389.854c0,.164-8.2.3-18.247.3s-18.247-.141-18.247-.3,8.2-.3,18.247-.3S702.424,389.679,702.424,389.854Z",
    transform: "translate(-149.275 -25.271)",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6322",
    "data-name": "Path 6322",
    d: "M523.148,470.734c-10.951,0-20.168-10.541-20.168-21.526s9.639-20.191,20.589-20.191l176.415-8.011a23.7,23.7,0,0,1,22.124,12.344,23.424,23.424,0,0,1,1.968,16.338c-4.685,21.315-22.381,21.081-29.28,20.6S523.148,470.734,523.148,470.734Z",
    transform: "translate(-177.169 -19.893)",
    fill: "#263238"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_339",
    "data-name": "Ellipse 339",
    cx: 16.479,
    cy: 16.479,
    r: 16.479,
    transform: "translate(329.5 412.707)",
    fill: "#455a64"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_340",
    "data-name": "Ellipse 340",
    cx: 21.316,
    cy: 21.316,
    r: 21.316,
    transform: "translate(500.388 404.521)",
    fill: "#455a64"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6323",
    "data-name": "Path 6323",
    d: "M698.368,424.49l-.457.07-1.347.152-5.177.515c-4.509.445-11.021,1.031-19.09,1.687-16.115,1.323-38.415,2.858-63.068,3.947s-47.023,1.523-63.244,1.616H526.825l-5.2-.07h-1.359a1.932,1.932,0,0,1-.457,0h7.015l19.161-.187c16.162-.211,38.508-.714,63.162-1.792s46.953-2.553,63.068-3.771l19.1-1.487,5.188-.41,1.359-.082a1.924,1.924,0,0,1,.5-.187Z",
    transform: "translate(-174.288 -19.29)",
    fill: "#455a64"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6324",
    "data-name": "Path 6324",
    d: "M691.524,458.635c0,.164-38.356.3-85.672.3s-85.672-.141-85.672-.3,38.344-.3,85.672-.3S691.524,458.459,691.524,458.635Z",
    transform: "translate(-174.225 -13.497)",
    fill: "#455a64"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6325",
    "data-name": "Path 6325",
    d: "M546.221,411.593a39.94,39.94,0,0,1-1.171-4.146c-.714-2.565-1.757-6.1-2.811-10.049a81.8,81.8,0,0,1-2.2-10.213,23.429,23.429,0,0,1-.187-3.174A3.9,3.9,0,0,1,540,382.84c.094,0,0,1.651.457,4.263s1.312,6.207,2.342,10.131,2.038,7.484,2.647,10.1c.3,1.3.539,2.342.656,3.092A4.064,4.064,0,0,1,546.221,411.593Z",
    transform: "translate(-170.857 -26.42)",
    fill: "#f30813"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6326",
    "data-name": "Path 6326",
    d: "M661.264,457.568a5.585,5.585,0,0,1-1.23-.808,14.777,14.777,0,0,1-2.741-2.893,16.5,16.5,0,0,1-2.565-5.352,15.483,15.483,0,0,1,2.694-13.867,16.668,16.668,0,0,1,4.38-3.994A14.85,14.85,0,0,1,665.445,429a5.694,5.694,0,0,1,1.429-.293,23.9,23.9,0,0,0-4.837,2.342,17.237,17.237,0,0,0-4.169,3.97,15.33,15.33,0,0,0-2.6,13.387,16.572,16.572,0,0,0,2.342,5.235A22.773,22.773,0,0,0,661.264,457.568Z",
    transform: "translate(-151.297 -18.568)",
    fill: "#fafafa"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6327",
    "data-name": "Path 6327",
    d: "M583.889,367.84a114.22,114.22,0,0,1-9.159,7.027,107.173,107.173,0,0,1-9.51,6.5,114.213,114.213,0,0,1,9.159-7.027A107.2,107.2,0,0,1,583.889,367.84Z",
    transform: "translate(-166.515 -28.987)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6328",
    "data-name": "Path 6328",
    d: "M584.743,363.59a82.418,82.418,0,0,1-7.976,5.95,81.08,81.08,0,0,1-8.327,5.446,84.744,84.744,0,0,1,7.976-5.95,81.983,81.983,0,0,1,8.327-5.446Z",
    transform: "translate(-165.963 -29.715)",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6329",
    "data-name": "Path 6329",
    d: "M554.234,370.15a21.084,21.084,0,0,1-4.041,3.186,22.075,22.075,0,0,1-4.4,2.694,22.54,22.54,0,0,1,4.052-3.186,21.818,21.818,0,0,1,4.392-2.694Z",
    transform: "translate(-169.84 -28.592)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6330",
    "data-name": "Path 6330",
    d: "M556.455,366.17a61.664,61.664,0,0,1-9.615,7.46,60.241,60.241,0,0,1,9.616-7.46Z",
    transform: "translate(-169.661 -29.273)",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6331",
    "data-name": "Path 6331",
    d: "M588.364,390.545a70.527,70.527,0,0,1-13.094,0,70.53,70.53,0,0,1,13.094,0Z",
    transform: "translate(-164.794 -25.153)",
    fill: "#f30813"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6332",
    "data-name": "Path 6332",
    d: "M519.1,461a4.989,4.989,0,0,1-1.429-.3,13.654,13.654,0,0,1-3.607-1.768,15.551,15.551,0,0,1-4.158-4.263,14.054,14.054,0,0,1-1-14.054,15.3,15.3,0,0,1,3.514-4.8,13.421,13.421,0,0,1,3.326-2.26,5.858,5.858,0,0,1,1.37-.5,20.686,20.686,0,0,0-4.392,3.08,15.52,15.52,0,0,0-3.314,4.685,13.808,13.808,0,0,0,.949,13.527,15.494,15.494,0,0,0,3.947,4.216A20.33,20.33,0,0,0,519.1,461Z",
    transform: "translate(-176.398 -17.826)",
    fill: "#fafafa"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6333",
    "data-name": "Path 6333",
    d: "M542.888,401.445c0,.164-6.348.3-14.183.3s-14.195-.141-14.195-.3,6.348-.3,14.195-.3S542.888,401.281,542.888,401.445Z",
    transform: "translate(-175.195 -23.287)",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6334",
    "data-name": "Path 6334",
    d: "M435.031,109.651,424.35,86.707a14.171,14.171,0,0,0-18.833-6.863h0a14.171,14.171,0,0,0-6.863,18.833l10.693,22.932a.855.855,0,0,0,1.171.422l24.126-11.243a.855.855,0,0,0,.386-1.136Z",
    transform: "translate(-195.255 -78.515)",
    fill: "#f30813"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-34",
    transform: "translate(62.191 413.801)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18229",
    "data-name": "Rectangle 18229",
    width: 6.02,
    height: 110.665,
    transform: "translate(17.474 9.861)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6335",
    "data-name": "Path 6335",
    d: "M84.3,366.237a6.067,6.067,0,1,1-6.067-6.067A6.067,6.067,0,0,1,84.3,366.237Z",
    transform: "translate(-57.729 -360.17)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18230",
    "data-name": "Rectangle 18230",
    width: 6.02,
    height: 110.665,
    transform: "translate(137.099 9.861)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6336",
    "data-name": "Path 6336",
    d: "M186.443,366.237a6.067,6.067,0,1,1-6.067-6.067A6.067,6.067,0,0,1,186.443,366.237Z",
    transform: "translate(-40.245 -360.17)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18231",
    "data-name": "Rectangle 18231",
    width: 154.233,
    height: 27.593,
    transform: "translate(0.293 20.543)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6337",
    "data-name": "Path 6337",
    d: "M77.541,377.7l-.269.468L61.425,405.3H60.09V377.7Z",
    transform: "translate(-59.797 -357.169)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6338",
    "data-name": "Path 6338",
    d: "M113.718,377.7,97.58,405.3H76.51l6.406-10.962L92.637,377.7Z",
    transform: "translate(-56.986 -357.169)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6339",
    "data-name": "Path 6339",
    d: "M146.988,377.7l-16.127,27.6H109.78l16.127-27.6Z",
    transform: "translate(-51.291 -357.169)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6340",
    "data-name": "Path 6340",
    d: "M180.247,377.71,164.12,405.3H143.05l16.127-27.593Z",
    transform: "translate(-45.596 -357.167)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6341",
    "data-name": "Path 6341",
    d: "M194.426,377.71V405.3H176.32l16.139-27.593Z",
    transform: "translate(-39.901 -357.167)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18232",
    "data-name": "Rectangle 18232",
    width: 154.233,
    height: 27.593,
    transform: "translate(0.293 63.162)",
    fill: "#f30813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6342",
    "data-name": "Path 6342",
    d: "M77.541,414.11l-.269.457L61.425,441.7H60.09V414.11Z",
    transform: "translate(-59.797 -350.936)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6343",
    "data-name": "Path 6343",
    d: "M113.718,414.11,97.58,441.7H76.51l6.406-10.962,9.721-16.631Z",
    transform: "translate(-56.986 -350.936)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6344",
    "data-name": "Path 6344",
    d: "M146.988,414.11,130.861,441.7H109.78l16.127-27.593Z",
    transform: "translate(-51.291 -350.936)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6345",
    "data-name": "Path 6345",
    d: "M180.247,414.11,164.12,441.7H143.05l16.127-27.593Z",
    transform: "translate(-45.596 -350.936)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M194.426,414.11V441.7H176.32l16.139-27.593Z",
    transform: "translate(-39.901 -350.936)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6347",
    "data-name": "Path 6347",
    d: "M214.366,405.349v-7.226c0-4.685-.059-11.571-.094-20.367l.164.152L60.145,378.1h0l.3-.3v27.593l-.3-.3,109.8.129,32.559.094h.141l-32.489.082-110.009.129h-.3V377.44h.316l154.221.152h.152v.164c0,8.831-.07,15.741-.082,20.461V404.9A.841.841,0,0,1,214.366,405.349Z",
    transform: "translate(-59.84 -357.214)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6348",
    "data-name": "Path 6348",
    d: "M214.355,441.749v-7.226c0-4.685-.059-11.571-.094-20.379l.164.164L60.2,414.449h0l.3-.3v27.6l-.3-.3,109.8.129,32.559.094h.141l-32.489.094L60.2,441.89h-.3V413.84h.316l154.221.152h.152v.152c0,8.842-.07,15.752-.082,20.472V441.3A.557.557,0,0,1,214.355,441.749Z",
    transform: "translate(-59.83 -350.983)",
    fill: "#263238"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-34",
    transform: "translate(53.266 534.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6349",
    "data-name": "Path 6349",
    d: "M812.973,463.5c0,.164-170.313.3-380.353.3s-380.4-.141-380.4-.3,170.278-.3,380.4-.3S812.973,463.329,812.973,463.5Z",
    transform: "translate(-52.22 -463.2)",
    fill: "#263238"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/under_construction.d578115c18592826c31e46ad43a1a839.svg";
export { ForwardRef as ReactComponent };